/* eslint-disable */
// @ts-nocheck
// source: internal/job.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var shared_types_decimal_pb = require('../shared/types/decimal_pb.js');
goog.object.extend(proto, shared_types_decimal_pb);
var shared_types_interval_pb = require('../shared/types/interval_pb.js');
goog.object.extend(proto, shared_types_interval_pb);
var internal_job_progression_pb = require('../internal/job_progression_pb.js');
goog.object.extend(proto, internal_job_progression_pb);
var internal_question_input_value_pb = require('../internal/question_input_value_pb.js');
goog.object.extend(proto, internal_question_input_value_pb);
var internal_consultation_pb = require('../internal/consultation_pb.js');
goog.object.extend(proto, internal_consultation_pb);
var internal_job_scope_change_pb = require('../internal/job_scope_change_pb.js');
goog.object.extend(proto, internal_job_scope_change_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.AmendmentVisibility', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.BatchGetJobsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.BatchGetJobsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.BulkCopyJobError', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.BulkCopyJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.BulkCopyJobResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ClaimConsultationJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ClaimJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ClaimJobResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CloseJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CloseJobResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CompleteInfoGatheringRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CompleteInfoGatheringResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CompleteTaskRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CompleteTaskResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ConsultationIncomplete', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ConsultationIncomplete.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ConsultationIncompleteReason', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ConsultationOtherIncompleteReason', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ConsultationPresetIncompleteReason', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CopyJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.CopyJobResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ForfeitJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ForfeitJobResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Amendment', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Answer', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.BillingType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.DeprecatedJobType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.InfoLine', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.JobScopeItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.JobType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.JobType.Bookkeeping', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.JobType.ConsultationJobType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.JobType.Misc', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.JobType.Tax', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.JobType.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Legend', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Legend.BillingConfig', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Legend.DeadlineConfig', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Legend.RatingConfig', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Legend.RatingConfig.CustomerRatingMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Member', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.MemberRole', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.MemberType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Milestone', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Milestone.MilestoneTask', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.TaskDesignee', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.PaymentInfoStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.PayoutSplit', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Job.PayoutSplit.Allocation', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobCreatedRealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobUpdatedRealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListJobQuestionsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListJobQuestionsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.MakeCorrectionsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.MakeCorrectionsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Member', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.MemberRoleType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.MemberType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Milestone', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.MilestoneTask', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.MilestoneTask.TaskDesignee', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.PlaceJobOnHoldRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.PlaceJobOnHoldResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.PurgeStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RemoveSupportingClientRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RemoveSupportingClientResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RenameJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RenameJobResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RequestJobChampionProviderRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RequestJobChampionProviderResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Resolution', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ResumeJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ResumeJobResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SearchJobScopeOption', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SearchJobsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SearchJobsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SearchableJob', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Status', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.UncompleteTaskRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.UncompleteTaskResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.WaitingOn', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.BatchGetJobsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.BatchGetJobsRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.BatchGetJobsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.BatchGetJobsRequest.displayName = 'proto.worklayer.internal.v1.BatchGetJobsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.BatchGetJobsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.BatchGetJobsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.BatchGetJobsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.BatchGetJobsResponse.displayName = 'proto.worklayer.internal.v1.BatchGetJobsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.displayName = 'proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RemoveSupportingClientRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RemoveSupportingClientRequest.displayName = 'proto.worklayer.internal.v1.RemoveSupportingClientRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RemoveSupportingClientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RemoveSupportingClientResponse.displayName = 'proto.worklayer.internal.v1.RemoveSupportingClientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.displayName = 'proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.displayName = 'proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetJobRequest.displayName = 'proto.worklayer.internal.v1.GetJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ClaimJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ClaimJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ClaimJobRequest.displayName = 'proto.worklayer.internal.v1.ClaimJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ClaimConsultationJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ClaimConsultationJobRequest.displayName = 'proto.worklayer.internal.v1.ClaimConsultationJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ClaimJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ClaimJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ClaimJobResponse.displayName = 'proto.worklayer.internal.v1.ClaimJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CloseJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CloseJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CloseJobRequest.displayName = 'proto.worklayer.internal.v1.CloseJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ConsultationIncomplete = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.ConsultationIncomplete.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.ConsultationIncomplete, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ConsultationIncomplete.displayName = 'proto.worklayer.internal.v1.ConsultationIncomplete';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ConsultationPresetIncompleteReason = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ConsultationPresetIncompleteReason, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.displayName = 'proto.worklayer.internal.v1.ConsultationPresetIncompleteReason';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ConsultationOtherIncompleteReason = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ConsultationOtherIncompleteReason, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.displayName = 'proto.worklayer.internal.v1.ConsultationOtherIncompleteReason';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CloseJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CloseJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CloseJobResponse.displayName = 'proto.worklayer.internal.v1.CloseJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RenameJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RenameJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RenameJobRequest.displayName = 'proto.worklayer.internal.v1.RenameJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RenameJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RenameJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RenameJobResponse.displayName = 'proto.worklayer.internal.v1.RenameJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.PlaceJobOnHoldRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.PlaceJobOnHoldRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.PlaceJobOnHoldRequest.displayName = 'proto.worklayer.internal.v1.PlaceJobOnHoldRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.PlaceJobOnHoldResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.PlaceJobOnHoldResponse.displayName = 'proto.worklayer.internal.v1.PlaceJobOnHoldResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CopyJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CopyJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CopyJobRequest.displayName = 'proto.worklayer.internal.v1.CopyJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.BulkCopyJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.BulkCopyJobRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.BulkCopyJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.BulkCopyJobRequest.displayName = 'proto.worklayer.internal.v1.BulkCopyJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CopyJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CopyJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CopyJobResponse.displayName = 'proto.worklayer.internal.v1.CopyJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.BulkCopyJobError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.BulkCopyJobError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.BulkCopyJobError.displayName = 'proto.worklayer.internal.v1.BulkCopyJobError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.BulkCopyJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.BulkCopyJobResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.BulkCopyJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.BulkCopyJobResponse.displayName = 'proto.worklayer.internal.v1.BulkCopyJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CompleteTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CompleteTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CompleteTaskRequest.displayName = 'proto.worklayer.internal.v1.CompleteTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CompleteTaskResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CompleteTaskResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CompleteTaskResponse.displayName = 'proto.worklayer.internal.v1.CompleteTaskResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.UncompleteTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.UncompleteTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.UncompleteTaskRequest.displayName = 'proto.worklayer.internal.v1.UncompleteTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.UncompleteTaskResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.UncompleteTaskResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.UncompleteTaskResponse.displayName = 'proto.worklayer.internal.v1.UncompleteTaskResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ResumeJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ResumeJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ResumeJobRequest.displayName = 'proto.worklayer.internal.v1.ResumeJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ResumeJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ResumeJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ResumeJobResponse.displayName = 'proto.worklayer.internal.v1.ResumeJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ForfeitJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ForfeitJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ForfeitJobRequest.displayName = 'proto.worklayer.internal.v1.ForfeitJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ForfeitJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ForfeitJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ForfeitJobResponse.displayName = 'proto.worklayer.internal.v1.ForfeitJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SearchJobsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SearchJobsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SearchJobsRequest.displayName = 'proto.worklayer.internal.v1.SearchJobsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SearchJobsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.SearchJobsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.SearchJobsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SearchJobsResponse.displayName = 'proto.worklayer.internal.v1.SearchJobsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SearchableJob = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.SearchableJob.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.SearchableJob, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SearchableJob.displayName = 'proto.worklayer.internal.v1.SearchableJob';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Member = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Member, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Member.displayName = 'proto.worklayer.internal.v1.Member';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Job.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Job, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.displayName = 'proto.worklayer.internal.v1.Job';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.JobScopeItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.JobScopeItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.JobScopeItem.displayName = 'proto.worklayer.internal.v1.Job.JobScopeItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Amendment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.Amendment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Amendment.displayName = 'proto.worklayer.internal.v1.Job.Amendment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Member = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.Member, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Member.displayName = 'proto.worklayer.internal.v1.Job.Member';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Legend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.Legend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Legend.displayName = 'proto.worklayer.internal.v1.Job.Legend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.Legend.DeadlineConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.displayName = 'proto.worklayer.internal.v1.Job.Legend.DeadlineConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.Legend.BillingConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Legend.BillingConfig.displayName = 'proto.worklayer.internal.v1.Job.Legend.BillingConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Job.Legend.RatingConfig.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.Legend.RatingConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Legend.RatingConfig.displayName = 'proto.worklayer.internal.v1.Job.Legend.RatingConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.displayName = 'proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.displayName = 'proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Milestone = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Job.Milestone.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.Milestone, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Milestone.displayName = 'proto.worklayer.internal.v1.Job.Milestone';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.Milestone.MilestoneTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.displayName = 'proto.worklayer.internal.v1.Job.Milestone.MilestoneTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.Answer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.Answer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.Answer.displayName = 'proto.worklayer.internal.v1.Job.Answer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.InfoLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.InfoLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.InfoLine.displayName = 'proto.worklayer.internal.v1.Job.InfoLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.PayoutSplit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Job.PayoutSplit.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.PayoutSplit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.PayoutSplit.displayName = 'proto.worklayer.internal.v1.Job.PayoutSplit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.PayoutSplit.Allocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.displayName = 'proto.worklayer.internal.v1.Job.PayoutSplit.Allocation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.JobType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.Job.JobType.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.Job.JobType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.JobType.displayName = 'proto.worklayer.internal.v1.Job.JobType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.JobType.Bookkeeping = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.JobType.Bookkeeping, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.JobType.Bookkeeping.displayName = 'proto.worklayer.internal.v1.Job.JobType.Bookkeeping';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.JobType.ConsultationJobType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.displayName = 'proto.worklayer.internal.v1.Job.JobType.ConsultationJobType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.JobType.Tax = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.JobType.Tax, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.JobType.Tax.displayName = 'proto.worklayer.internal.v1.Job.JobType.Tax';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.displayName = 'proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.displayName = 'proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Job.JobType.Misc = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Job.JobType.Misc, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Job.JobType.Misc.displayName = 'proto.worklayer.internal.v1.Job.JobType.Misc';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ListJobQuestionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListJobQuestionsRequest.displayName = 'proto.worklayer.internal.v1.ListJobQuestionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListJobQuestionsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListJobQuestionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListJobQuestionsResponse.displayName = 'proto.worklayer.internal.v1.ListJobQuestionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Milestone = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Milestone.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Milestone, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Milestone.displayName = 'proto.worklayer.internal.v1.Milestone';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.MilestoneTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.MilestoneTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.MilestoneTask.displayName = 'proto.worklayer.internal.v1.MilestoneTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobCreatedRealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobCreatedRealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobCreatedRealtimeEvent.displayName = 'proto.worklayer.internal.v1.JobCreatedRealtimeEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobUpdatedRealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.displayName = 'proto.worklayer.internal.v1.JobUpdatedRealtimeEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.MakeCorrectionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.MakeCorrectionsRequest.displayName = 'proto.worklayer.internal.v1.MakeCorrectionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.MakeCorrectionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.MakeCorrectionsResponse.displayName = 'proto.worklayer.internal.v1.MakeCorrectionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CompleteInfoGatheringRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CompleteInfoGatheringRequest.displayName = 'proto.worklayer.internal.v1.CompleteInfoGatheringRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.CompleteInfoGatheringResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.CompleteInfoGatheringResponse.displayName = 'proto.worklayer.internal.v1.CompleteInfoGatheringResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RequestJobChampionProviderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RequestJobChampionProviderRequest.displayName = 'proto.worklayer.internal.v1.RequestJobChampionProviderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RequestJobChampionProviderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RequestJobChampionProviderResponse.displayName = 'proto.worklayer.internal.v1.RequestJobChampionProviderResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.BatchGetJobsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.BatchGetJobsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsRequest}
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.BatchGetJobsRequest;
  return proto.worklayer.internal.v1.BatchGetJobsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.BatchGetJobsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsRequest}
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.BatchGetJobsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.BatchGetJobsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.BatchGetJobsRequest} returns this
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.BatchGetJobsRequest} returns this
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsRequest} returns this
 */
proto.worklayer.internal.v1.BatchGetJobsRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.BatchGetJobsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.BatchGetJobsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobsList: jspb.Message.toObjectList(msg.getJobsList(),
    proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.BatchGetJobsResponse;
  return proto.worklayer.internal.v1.BatchGetJobsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.BatchGetJobsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation;
      reader.readMessage(value,proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.deserializeBinaryFromReader);
      msg.addJobs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.BatchGetJobsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.BatchGetJobsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.TypeCase = {
  TYPE_NOT_SET: 0,
  ADMIN_VIEW: 1,
  COLLABORATOR_VIEW: 2,
  EMPTY: 3
};

/**
 * @return {proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.TypeCase}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.toObject = function(includeInstance, msg) {
  var f, obj = {
    adminView: (f = msg.getAdminView()) && proto.worklayer.internal.v1.Job.toObject(includeInstance, f),
    collaboratorView: (f = msg.getCollaboratorView()) && proto.worklayer.internal.v1.Job.toObject(includeInstance, f),
    empty: (f = msg.getEmpty()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation;
  return proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.Job;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.deserializeBinaryFromReader);
      msg.setAdminView(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.Job;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.deserializeBinaryFromReader);
      msg.setCollaboratorView(value);
      break;
    case 3:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setEmpty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdminView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.Job.serializeBinaryToWriter
    );
  }
  f = message.getCollaboratorView();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.Job.serializeBinaryToWriter
    );
  }
  f = message.getEmpty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
};


/**
 * optional Job admin_view = 1;
 * @return {?proto.worklayer.internal.v1.Job}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.getAdminView = function() {
  return /** @type{?proto.worklayer.internal.v1.Job} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.Job|undefined} value
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation} returns this
*/
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.setAdminView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation} returns this
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.clearAdminView = function() {
  return this.setAdminView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.hasAdminView = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Job collaborator_view = 2;
 * @return {?proto.worklayer.internal.v1.Job}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.getCollaboratorView = function() {
  return /** @type{?proto.worklayer.internal.v1.Job} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.Job|undefined} value
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation} returns this
*/
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.setCollaboratorView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation} returns this
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.clearCollaboratorView = function() {
  return this.setCollaboratorView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.hasCollaboratorView = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Empty empty = 3;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.getEmpty = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 3));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation} returns this
*/
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.setEmpty = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation} returns this
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.clearEmpty = function() {
  return this.setEmpty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation.prototype.hasEmpty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated BatchJobRepresentation jobs = 1;
 * @return {!Array<!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation>}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.prototype.getJobsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation>} value
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse} returns this
*/
proto.worklayer.internal.v1.BatchGetJobsResponse.prototype.setJobsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation}
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.prototype.addJobs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.BatchGetJobsResponse.BatchJobRepresentation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.BatchGetJobsResponse} returns this
 */
proto.worklayer.internal.v1.BatchGetJobsResponse.prototype.clearJobsList = function() {
  return this.setJobsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RemoveSupportingClientRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RemoveSupportingClientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    clientUserPublicId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingClientRequest}
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RemoveSupportingClientRequest;
  return proto.worklayer.internal.v1.RemoveSupportingClientRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingClientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingClientRequest}
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientUserPublicId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RemoveSupportingClientRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingClientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RemoveSupportingClientRequest} returns this
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_user_public_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest.prototype.getClientUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RemoveSupportingClientRequest} returns this
 */
proto.worklayer.internal.v1.RemoveSupportingClientRequest.prototype.setClientUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RemoveSupportingClientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RemoveSupportingClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingClientResponse}
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RemoveSupportingClientResponse;
  return proto.worklayer.internal.v1.RemoveSupportingClientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingClientResponse}
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RemoveSupportingClientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RemoveSupportingClientResponse} returns this
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.RemoveSupportingClientResponse} returns this
*/
proto.worklayer.internal.v1.RemoveSupportingClientResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingClientResponse} returns this
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RemoveSupportingClientResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse;
  return proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse} returns this
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse} returns this
*/
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse} returns this
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userPublicId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest;
  return proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPublicId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest} returns this
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_public_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.prototype.getUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest} returns this
 */
proto.worklayer.internal.v1.AddTeamMemberAsSupportingClientRequest.prototype.setUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    includeArchived: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetJobRequest}
 */
proto.worklayer.internal.v1.GetJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetJobRequest;
  return proto.worklayer.internal.v1.GetJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetJobRequest}
 */
proto.worklayer.internal.v1.GetJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIncludeArchived();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetJobRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetJobRequest} returns this
 */
proto.worklayer.internal.v1.GetJobRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool include_archived = 2;
 * @return {boolean}
 */
proto.worklayer.internal.v1.GetJobRequest.prototype.getIncludeArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.GetJobRequest} returns this
 */
proto.worklayer.internal.v1.GetJobRequest.prototype.setIncludeArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ClaimJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ClaimJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ClaimJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ClaimJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ClaimJobRequest}
 */
proto.worklayer.internal.v1.ClaimJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ClaimJobRequest;
  return proto.worklayer.internal.v1.ClaimJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ClaimJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ClaimJobRequest}
 */
proto.worklayer.internal.v1.ClaimJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ClaimJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ClaimJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ClaimJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ClaimJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ClaimJobRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ClaimJobRequest} returns this
 */
proto.worklayer.internal.v1.ClaimJobRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ClaimConsultationJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ClaimConsultationJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bookedTime: (f = msg.getBookedTime()) && shared_types_interval_pb.Interval.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ClaimConsultationJobRequest}
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ClaimConsultationJobRequest;
  return proto.worklayer.internal.v1.ClaimConsultationJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ClaimConsultationJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ClaimConsultationJobRequest}
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new shared_types_interval_pb.Interval;
      reader.readMessage(value,shared_types_interval_pb.Interval.deserializeBinaryFromReader);
      msg.setBookedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ClaimConsultationJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ClaimConsultationJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBookedTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_types_interval_pb.Interval.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ClaimConsultationJobRequest} returns this
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional worklayer.shared.types.v1.Interval booked_time = 2;
 * @return {?proto.worklayer.shared.types.v1.Interval}
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.prototype.getBookedTime = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Interval} */ (
    jspb.Message.getWrapperField(this, shared_types_interval_pb.Interval, 2));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Interval|undefined} value
 * @return {!proto.worklayer.internal.v1.ClaimConsultationJobRequest} returns this
*/
proto.worklayer.internal.v1.ClaimConsultationJobRequest.prototype.setBookedTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.ClaimConsultationJobRequest} returns this
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.prototype.clearBookedTime = function() {
  return this.setBookedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.ClaimConsultationJobRequest.prototype.hasBookedTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ClaimJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ClaimJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ClaimJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ClaimJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ClaimJobResponse}
 */
proto.worklayer.internal.v1.ClaimJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ClaimJobResponse;
  return proto.worklayer.internal.v1.ClaimJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ClaimJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ClaimJobResponse}
 */
proto.worklayer.internal.v1.ClaimJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.worklayer.internal.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ClaimJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ClaimJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ClaimJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ClaimJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {!proto.worklayer.internal.v1.Status}
 */
proto.worklayer.internal.v1.ClaimJobResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Status} value
 * @return {!proto.worklayer.internal.v1.ClaimJobResponse} returns this
 */
proto.worklayer.internal.v1.ClaimJobResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.ClaimJobResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.ClaimJobResponse} returns this
*/
proto.worklayer.internal.v1.ClaimJobResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.ClaimJobResponse} returns this
 */
proto.worklayer.internal.v1.ClaimJobResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.ClaimJobResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CloseJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CloseJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CloseJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ratingReceived: (f = msg.getRatingReceived()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    ratingReceivedComment: jspb.Message.getFieldWithDefault(msg, 4, ""),
    consultationIncomplete: (f = msg.getConsultationIncomplete()) && proto.worklayer.internal.v1.ConsultationIncomplete.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CloseJobRequest}
 */
proto.worklayer.internal.v1.CloseJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CloseJobRequest;
  return proto.worklayer.internal.v1.CloseJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CloseJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CloseJobRequest}
 */
proto.worklayer.internal.v1.CloseJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setRatingReceived(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRatingReceivedComment(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.ConsultationIncomplete;
      reader.readMessage(value,proto.worklayer.internal.v1.ConsultationIncomplete.deserializeBinaryFromReader);
      msg.setConsultationIncomplete(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CloseJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CloseJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CloseJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRatingReceived();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getRatingReceivedComment();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getConsultationIncomplete();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.ConsultationIncomplete.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CloseJobRequest} returns this
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal rating_received = 2;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.getRatingReceived = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 2));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.CloseJobRequest} returns this
*/
proto.worklayer.internal.v1.CloseJobRequest.prototype.setRatingReceived = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CloseJobRequest} returns this
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.clearRatingReceived = function() {
  return this.setRatingReceived(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.hasRatingReceived = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string rating_received_comment = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.getRatingReceivedComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CloseJobRequest} returns this
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.setRatingReceivedComment = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional ConsultationIncomplete consultation_incomplete = 5;
 * @return {?proto.worklayer.internal.v1.ConsultationIncomplete}
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.getConsultationIncomplete = function() {
  return /** @type{?proto.worklayer.internal.v1.ConsultationIncomplete} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ConsultationIncomplete, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.ConsultationIncomplete|undefined} value
 * @return {!proto.worklayer.internal.v1.CloseJobRequest} returns this
*/
proto.worklayer.internal.v1.CloseJobRequest.prototype.setConsultationIncomplete = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CloseJobRequest} returns this
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.clearConsultationIncomplete = function() {
  return this.setConsultationIncomplete(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CloseJobRequest.prototype.hasConsultationIncomplete = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.ConsultationIncomplete.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.ConsultationIncomplete.TypeCase = {
  TYPE_NOT_SET: 0,
  INCOMPLETE_REASON: 1,
  OTHER_INCOMPLETE_REASON: 2
};

/**
 * @return {proto.worklayer.internal.v1.ConsultationIncomplete.TypeCase}
 */
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.ConsultationIncomplete.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.ConsultationIncomplete.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ConsultationIncomplete.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ConsultationIncomplete} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ConsultationIncomplete.toObject = function(includeInstance, msg) {
  var f, obj = {
    incompleteReason: (f = msg.getIncompleteReason()) && proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.toObject(includeInstance, f),
    otherIncompleteReason: (f = msg.getOtherIncompleteReason()) && proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ConsultationIncomplete}
 */
proto.worklayer.internal.v1.ConsultationIncomplete.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ConsultationIncomplete;
  return proto.worklayer.internal.v1.ConsultationIncomplete.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ConsultationIncomplete} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ConsultationIncomplete}
 */
proto.worklayer.internal.v1.ConsultationIncomplete.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.ConsultationPresetIncompleteReason;
      reader.readMessage(value,proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.deserializeBinaryFromReader);
      msg.setIncompleteReason(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.ConsultationOtherIncompleteReason;
      reader.readMessage(value,proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.deserializeBinaryFromReader);
      msg.setOtherIncompleteReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ConsultationIncomplete.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ConsultationIncomplete} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ConsultationIncomplete.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncompleteReason();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.serializeBinaryToWriter
    );
  }
  f = message.getOtherIncompleteReason();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.serializeBinaryToWriter
    );
  }
};


/**
 * optional ConsultationPresetIncompleteReason incomplete_reason = 1;
 * @return {?proto.worklayer.internal.v1.ConsultationPresetIncompleteReason}
 */
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.getIncompleteReason = function() {
  return /** @type{?proto.worklayer.internal.v1.ConsultationPresetIncompleteReason} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ConsultationPresetIncompleteReason, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.ConsultationPresetIncompleteReason|undefined} value
 * @return {!proto.worklayer.internal.v1.ConsultationIncomplete} returns this
*/
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.setIncompleteReason = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.ConsultationIncomplete.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.ConsultationIncomplete} returns this
 */
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.clearIncompleteReason = function() {
  return this.setIncompleteReason(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.hasIncompleteReason = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ConsultationOtherIncompleteReason other_incomplete_reason = 2;
 * @return {?proto.worklayer.internal.v1.ConsultationOtherIncompleteReason}
 */
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.getOtherIncompleteReason = function() {
  return /** @type{?proto.worklayer.internal.v1.ConsultationOtherIncompleteReason} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ConsultationOtherIncompleteReason, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.ConsultationOtherIncompleteReason|undefined} value
 * @return {!proto.worklayer.internal.v1.ConsultationIncomplete} returns this
*/
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.setOtherIncompleteReason = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.ConsultationIncomplete.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.ConsultationIncomplete} returns this
 */
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.clearOtherIncompleteReason = function() {
  return this.setOtherIncompleteReason(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.ConsultationIncomplete.prototype.hasOtherIncompleteReason = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ConsultationPresetIncompleteReason} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.toObject = function(includeInstance, msg) {
  var f, obj = {
    reason: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ConsultationPresetIncompleteReason}
 */
proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ConsultationPresetIncompleteReason;
  return proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ConsultationPresetIncompleteReason} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ConsultationPresetIncompleteReason}
 */
proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.worklayer.internal.v1.ConsultationIncompleteReason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ConsultationPresetIncompleteReason} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ConsultationIncompleteReason reason = 1;
 * @return {!proto.worklayer.internal.v1.ConsultationIncompleteReason}
 */
proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.prototype.getReason = function() {
  return /** @type {!proto.worklayer.internal.v1.ConsultationIncompleteReason} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.ConsultationIncompleteReason} value
 * @return {!proto.worklayer.internal.v1.ConsultationPresetIncompleteReason} returns this
 */
proto.worklayer.internal.v1.ConsultationPresetIncompleteReason.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ConsultationOtherIncompleteReason} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.toObject = function(includeInstance, msg) {
  var f, obj = {
    reason: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ConsultationOtherIncompleteReason}
 */
proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ConsultationOtherIncompleteReason;
  return proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ConsultationOtherIncompleteReason} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ConsultationOtherIncompleteReason}
 */
proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ConsultationOtherIncompleteReason} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string reason = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ConsultationOtherIncompleteReason} returns this
 */
proto.worklayer.internal.v1.ConsultationOtherIncompleteReason.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CloseJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CloseJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CloseJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CloseJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    closeTime: (f = msg.getCloseTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CloseJobResponse}
 */
proto.worklayer.internal.v1.CloseJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CloseJobResponse;
  return proto.worklayer.internal.v1.CloseJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CloseJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CloseJobResponse}
 */
proto.worklayer.internal.v1.CloseJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.worklayer.internal.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCloseTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CloseJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CloseJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CloseJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CloseJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCloseTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {!proto.worklayer.internal.v1.Status}
 */
proto.worklayer.internal.v1.CloseJobResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Status} value
 * @return {!proto.worklayer.internal.v1.CloseJobResponse} returns this
 */
proto.worklayer.internal.v1.CloseJobResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp close_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.CloseJobResponse.prototype.getCloseTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.CloseJobResponse} returns this
*/
proto.worklayer.internal.v1.CloseJobResponse.prototype.setCloseTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CloseJobResponse} returns this
 */
proto.worklayer.internal.v1.CloseJobResponse.prototype.clearCloseTime = function() {
  return this.setCloseTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CloseJobResponse.prototype.hasCloseTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RenameJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RenameJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RenameJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RenameJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RenameJobRequest}
 */
proto.worklayer.internal.v1.RenameJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RenameJobRequest;
  return proto.worklayer.internal.v1.RenameJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RenameJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RenameJobRequest}
 */
proto.worklayer.internal.v1.RenameJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RenameJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RenameJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RenameJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RenameJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RenameJobRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RenameJobRequest} returns this
 */
proto.worklayer.internal.v1.RenameJobRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.RenameJobRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RenameJobRequest} returns this
 */
proto.worklayer.internal.v1.RenameJobRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RenameJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RenameJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RenameJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RenameJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RenameJobResponse}
 */
proto.worklayer.internal.v1.RenameJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RenameJobResponse;
  return proto.worklayer.internal.v1.RenameJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RenameJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RenameJobResponse}
 */
proto.worklayer.internal.v1.RenameJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RenameJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RenameJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RenameJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RenameJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RenameJobResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RenameJobResponse} returns this
 */
proto.worklayer.internal.v1.RenameJobResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.RenameJobResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.RenameJobResponse} returns this
*/
proto.worklayer.internal.v1.RenameJobResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RenameJobResponse} returns this
 */
proto.worklayer.internal.v1.RenameJobResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RenameJobResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.PlaceJobOnHoldRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.PlaceJobOnHoldRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.PlaceJobOnHoldRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.PlaceJobOnHoldRequest}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.PlaceJobOnHoldRequest;
  return proto.worklayer.internal.v1.PlaceJobOnHoldRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.PlaceJobOnHoldRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.PlaceJobOnHoldRequest}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.PlaceJobOnHoldRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.PlaceJobOnHoldRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.PlaceJobOnHoldRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.PlaceJobOnHoldRequest} returns this
 */
proto.worklayer.internal.v1.PlaceJobOnHoldRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.PlaceJobOnHoldResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.PlaceJobOnHoldResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.PlaceJobOnHoldResponse}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.PlaceJobOnHoldResponse;
  return proto.worklayer.internal.v1.PlaceJobOnHoldResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.PlaceJobOnHoldResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.PlaceJobOnHoldResponse}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.worklayer.internal.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.PlaceJobOnHoldResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.PlaceJobOnHoldResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {!proto.worklayer.internal.v1.Status}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Status} value
 * @return {!proto.worklayer.internal.v1.PlaceJobOnHoldResponse} returns this
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.PlaceJobOnHoldResponse} returns this
*/
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.PlaceJobOnHoldResponse} returns this
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.PlaceJobOnHoldResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CopyJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CopyJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CopyJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CopyJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CopyJobRequest}
 */
proto.worklayer.internal.v1.CopyJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CopyJobRequest;
  return proto.worklayer.internal.v1.CopyJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CopyJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CopyJobRequest}
 */
proto.worklayer.internal.v1.CopyJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CopyJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CopyJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CopyJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CopyJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CopyJobRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CopyJobRequest} returns this
 */
proto.worklayer.internal.v1.CopyJobRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.BulkCopyJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.BulkCopyJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.BulkCopyJobRequest}
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.BulkCopyJobRequest;
  return proto.worklayer.internal.v1.BulkCopyJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.BulkCopyJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.BulkCopyJobRequest}
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.BulkCopyJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.BulkCopyJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.BulkCopyJobRequest} returns this
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.BulkCopyJobRequest} returns this
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.BulkCopyJobRequest} returns this
 */
proto.worklayer.internal.v1.BulkCopyJobRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CopyJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CopyJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CopyJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CopyJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    readyForSubmission: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CopyJobResponse}
 */
proto.worklayer.internal.v1.CopyJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CopyJobResponse;
  return proto.worklayer.internal.v1.CopyJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CopyJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CopyJobResponse}
 */
proto.worklayer.internal.v1.CopyJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReadyForSubmission(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CopyJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CopyJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CopyJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CopyJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReadyForSubmission();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CopyJobResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CopyJobResponse} returns this
 */
proto.worklayer.internal.v1.CopyJobResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp create_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.CopyJobResponse.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.CopyJobResponse} returns this
*/
proto.worklayer.internal.v1.CopyJobResponse.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CopyJobResponse} returns this
 */
proto.worklayer.internal.v1.CopyJobResponse.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CopyJobResponse.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool ready_for_submission = 3;
 * @return {boolean}
 */
proto.worklayer.internal.v1.CopyJobResponse.prototype.getReadyForSubmission = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.CopyJobResponse} returns this
 */
proto.worklayer.internal.v1.CopyJobResponse.prototype.setReadyForSubmission = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.BulkCopyJobError.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.BulkCopyJobError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.BulkCopyJobError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BulkCopyJobError.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.BulkCopyJobError}
 */
proto.worklayer.internal.v1.BulkCopyJobError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.BulkCopyJobError;
  return proto.worklayer.internal.v1.BulkCopyJobError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.BulkCopyJobError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.BulkCopyJobError}
 */
proto.worklayer.internal.v1.BulkCopyJobError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.BulkCopyJobError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.BulkCopyJobError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.BulkCopyJobError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BulkCopyJobError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.BulkCopyJobError.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.BulkCopyJobError} returns this
 */
proto.worklayer.internal.v1.BulkCopyJobError.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.BulkCopyJobError.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.BulkCopyJobError} returns this
 */
proto.worklayer.internal.v1.BulkCopyJobError.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.BulkCopyJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.BulkCopyJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    errorsList: jspb.Message.toObjectList(msg.getErrorsList(),
    proto.worklayer.internal.v1.BulkCopyJobError.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.BulkCopyJobResponse}
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.BulkCopyJobResponse;
  return proto.worklayer.internal.v1.BulkCopyJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.BulkCopyJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.BulkCopyJobResponse}
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.BulkCopyJobError;
      reader.readMessage(value,proto.worklayer.internal.v1.BulkCopyJobError.deserializeBinaryFromReader);
      msg.addErrors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.BulkCopyJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.BulkCopyJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.worklayer.internal.v1.BulkCopyJobError.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.BulkCopyJobResponse} returns this
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.BulkCopyJobResponse} returns this
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.BulkCopyJobResponse} returns this
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


/**
 * repeated BulkCopyJobError errors = 2;
 * @return {!Array<!proto.worklayer.internal.v1.BulkCopyJobError>}
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.prototype.getErrorsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.BulkCopyJobError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.BulkCopyJobError, 2));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.BulkCopyJobError>} value
 * @return {!proto.worklayer.internal.v1.BulkCopyJobResponse} returns this
*/
proto.worklayer.internal.v1.BulkCopyJobResponse.prototype.setErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.worklayer.internal.v1.BulkCopyJobError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.BulkCopyJobError}
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.prototype.addErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.worklayer.internal.v1.BulkCopyJobError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.BulkCopyJobResponse} returns this
 */
proto.worklayer.internal.v1.BulkCopyJobResponse.prototype.clearErrorsList = function() {
  return this.setErrorsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CompleteTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CompleteTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CompleteTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CompleteTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    taskId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CompleteTaskRequest}
 */
proto.worklayer.internal.v1.CompleteTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CompleteTaskRequest;
  return proto.worklayer.internal.v1.CompleteTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CompleteTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CompleteTaskRequest}
 */
proto.worklayer.internal.v1.CompleteTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CompleteTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CompleteTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CompleteTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CompleteTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CompleteTaskRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CompleteTaskRequest} returns this
 */
proto.worklayer.internal.v1.CompleteTaskRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.CompleteTaskRequest.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CompleteTaskRequest} returns this
 */
proto.worklayer.internal.v1.CompleteTaskRequest.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CompleteTaskResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CompleteTaskResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CompleteTaskResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CompleteTaskResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CompleteTaskResponse}
 */
proto.worklayer.internal.v1.CompleteTaskResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CompleteTaskResponse;
  return proto.worklayer.internal.v1.CompleteTaskResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CompleteTaskResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CompleteTaskResponse}
 */
proto.worklayer.internal.v1.CompleteTaskResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CompleteTaskResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CompleteTaskResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CompleteTaskResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CompleteTaskResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CompleteTaskResponse.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CompleteTaskResponse} returns this
 */
proto.worklayer.internal.v1.CompleteTaskResponse.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.CompleteTaskResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.CompleteTaskResponse} returns this
*/
proto.worklayer.internal.v1.CompleteTaskResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CompleteTaskResponse} returns this
 */
proto.worklayer.internal.v1.CompleteTaskResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CompleteTaskResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.UncompleteTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.UncompleteTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.UncompleteTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UncompleteTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    taskId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.UncompleteTaskRequest}
 */
proto.worklayer.internal.v1.UncompleteTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.UncompleteTaskRequest;
  return proto.worklayer.internal.v1.UncompleteTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.UncompleteTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.UncompleteTaskRequest}
 */
proto.worklayer.internal.v1.UncompleteTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.UncompleteTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.UncompleteTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.UncompleteTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UncompleteTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.UncompleteTaskRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UncompleteTaskRequest} returns this
 */
proto.worklayer.internal.v1.UncompleteTaskRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.UncompleteTaskRequest.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UncompleteTaskRequest} returns this
 */
proto.worklayer.internal.v1.UncompleteTaskRequest.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.UncompleteTaskResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.UncompleteTaskResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.UncompleteTaskResponse}
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.UncompleteTaskResponse;
  return proto.worklayer.internal.v1.UncompleteTaskResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.UncompleteTaskResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.UncompleteTaskResponse}
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.UncompleteTaskResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.UncompleteTaskResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UncompleteTaskResponse} returns this
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.UncompleteTaskResponse} returns this
*/
proto.worklayer.internal.v1.UncompleteTaskResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.UncompleteTaskResponse} returns this
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.UncompleteTaskResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ResumeJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ResumeJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ResumeJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ResumeJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ResumeJobRequest}
 */
proto.worklayer.internal.v1.ResumeJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ResumeJobRequest;
  return proto.worklayer.internal.v1.ResumeJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ResumeJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ResumeJobRequest}
 */
proto.worklayer.internal.v1.ResumeJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ResumeJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ResumeJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ResumeJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ResumeJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ResumeJobRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ResumeJobRequest} returns this
 */
proto.worklayer.internal.v1.ResumeJobRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ResumeJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ResumeJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ResumeJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ResumeJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ResumeJobResponse}
 */
proto.worklayer.internal.v1.ResumeJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ResumeJobResponse;
  return proto.worklayer.internal.v1.ResumeJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ResumeJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ResumeJobResponse}
 */
proto.worklayer.internal.v1.ResumeJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.worklayer.internal.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ResumeJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ResumeJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ResumeJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ResumeJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {!proto.worklayer.internal.v1.Status}
 */
proto.worklayer.internal.v1.ResumeJobResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Status} value
 * @return {!proto.worklayer.internal.v1.ResumeJobResponse} returns this
 */
proto.worklayer.internal.v1.ResumeJobResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.ResumeJobResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.ResumeJobResponse} returns this
*/
proto.worklayer.internal.v1.ResumeJobResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.ResumeJobResponse} returns this
 */
proto.worklayer.internal.v1.ResumeJobResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.ResumeJobResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ForfeitJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ForfeitJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ForfeitJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ForfeitJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ForfeitJobRequest}
 */
proto.worklayer.internal.v1.ForfeitJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ForfeitJobRequest;
  return proto.worklayer.internal.v1.ForfeitJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ForfeitJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ForfeitJobRequest}
 */
proto.worklayer.internal.v1.ForfeitJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ForfeitJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ForfeitJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ForfeitJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ForfeitJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ForfeitJobRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ForfeitJobRequest} returns this
 */
proto.worklayer.internal.v1.ForfeitJobRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ForfeitJobRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ForfeitJobRequest} returns this
 */
proto.worklayer.internal.v1.ForfeitJobRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ForfeitJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ForfeitJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ForfeitJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ForfeitJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ForfeitJobResponse}
 */
proto.worklayer.internal.v1.ForfeitJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ForfeitJobResponse;
  return proto.worklayer.internal.v1.ForfeitJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ForfeitJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ForfeitJobResponse}
 */
proto.worklayer.internal.v1.ForfeitJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.worklayer.internal.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ForfeitJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ForfeitJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ForfeitJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ForfeitJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {!proto.worklayer.internal.v1.Status}
 */
proto.worklayer.internal.v1.ForfeitJobResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Status} value
 * @return {!proto.worklayer.internal.v1.ForfeitJobResponse} returns this
 */
proto.worklayer.internal.v1.ForfeitJobResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.ForfeitJobResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.ForfeitJobResponse} returns this
*/
proto.worklayer.internal.v1.ForfeitJobResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.ForfeitJobResponse} returns this
 */
proto.worklayer.internal.v1.ForfeitJobResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.ForfeitJobResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SearchJobsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SearchJobsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SearchJobsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    searchText: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filter: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderBy: jspb.Message.getFieldWithDefault(msg, 3, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 5, ""),
    scope: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SearchJobsRequest}
 */
proto.worklayer.internal.v1.SearchJobsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SearchJobsRequest;
  return proto.worklayer.internal.v1.SearchJobsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SearchJobsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SearchJobsRequest}
 */
proto.worklayer.internal.v1.SearchJobsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchText(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilter(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderBy(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 6:
      var value = /** @type {!proto.worklayer.internal.v1.SearchJobScopeOption} */ (reader.readEnum());
      msg.setScope(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SearchJobsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SearchJobsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SearchJobsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilter();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderBy();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getScope();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string search_text = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.getSearchText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchJobsRequest} returns this
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.setSearchText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filter = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.getFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchJobsRequest} returns this
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.setFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string order_by = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.getOrderBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchJobsRequest} returns this
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.SearchJobsRequest} returns this
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string page_token = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchJobsRequest} returns this
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional SearchJobScopeOption scope = 6;
 * @return {!proto.worklayer.internal.v1.SearchJobScopeOption}
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.getScope = function() {
  return /** @type {!proto.worklayer.internal.v1.SearchJobScopeOption} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.SearchJobScopeOption} value
 * @return {!proto.worklayer.internal.v1.SearchJobsRequest} returns this
 */
proto.worklayer.internal.v1.SearchJobsRequest.prototype.setScope = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.SearchJobsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SearchJobsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SearchJobsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SearchJobsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SearchJobsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobsList: jspb.Message.toObjectList(msg.getJobsList(),
    proto.worklayer.internal.v1.SearchableJob.toObject, includeInstance),
    totalSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SearchJobsResponse}
 */
proto.worklayer.internal.v1.SearchJobsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SearchJobsResponse;
  return proto.worklayer.internal.v1.SearchJobsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SearchJobsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SearchJobsResponse}
 */
proto.worklayer.internal.v1.SearchJobsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.SearchableJob;
      reader.readMessage(value,proto.worklayer.internal.v1.SearchableJob.deserializeBinaryFromReader);
      msg.addJobs(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SearchJobsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SearchJobsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SearchJobsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SearchJobsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.SearchableJob.serializeBinaryToWriter
    );
  }
  f = message.getTotalSize();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated SearchableJob jobs = 1;
 * @return {!Array<!proto.worklayer.internal.v1.SearchableJob>}
 */
proto.worklayer.internal.v1.SearchJobsResponse.prototype.getJobsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.SearchableJob>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.SearchableJob, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.SearchableJob>} value
 * @return {!proto.worklayer.internal.v1.SearchJobsResponse} returns this
*/
proto.worklayer.internal.v1.SearchJobsResponse.prototype.setJobsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.SearchableJob=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.SearchableJob}
 */
proto.worklayer.internal.v1.SearchJobsResponse.prototype.addJobs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.SearchableJob, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.SearchJobsResponse} returns this
 */
proto.worklayer.internal.v1.SearchJobsResponse.prototype.clearJobsList = function() {
  return this.setJobsList([]);
};


/**
 * optional int64 total_size = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.SearchJobsResponse.prototype.getTotalSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.SearchJobsResponse} returns this
 */
proto.worklayer.internal.v1.SearchJobsResponse.prototype.setTotalSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string next_page_token = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchJobsResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchJobsResponse} returns this
 */
proto.worklayer.internal.v1.SearchJobsResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.SearchableJob.repeatedFields_ = [18,19,21,29];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SearchableJob.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SearchableJob} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SearchableJob.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    shortId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    legendName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    clientTeamName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    clientTeamId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    proTeamName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    proTeamId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    resolution: jspb.Message.getFieldWithDefault(msg, 9, 0),
    waitingOn: jspb.Message.getFieldWithDefault(msg, 10, 0),
    status: jspb.Message.getFieldWithDefault(msg, 11, 0),
    workspaceName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    dateCreated: (f = msg.getDateCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateSubmitted: (f = msg.getDateSubmitted()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateDeadline: (f = msg.getDateDeadline()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateCompleted: (f = msg.getDateCompleted()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateClaimed: (f = msg.getDateClaimed()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    milestonesList: jspb.Message.toObjectList(msg.getMilestonesList(),
    proto.worklayer.internal.v1.Milestone.toObject, includeInstance),
    jobSpecsList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    workspaceId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.worklayer.internal.v1.Member.toObject, includeInstance),
    providerCutAmount: (f = msg.getProviderCutAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    conversationId: (f = msg.getConversationId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    archived: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    dateModified: (f = msg.getDateModified()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateLastActivity: (f = msg.getDateLastActivity()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    description: jspb.Message.getFieldWithDefault(msg, 27, ""),
    progressionStep: jspb.Message.getFieldWithDefault(msg, 28, 0),
    jobScopeItemsList: (f = jspb.Message.getRepeatedField(msg, 29)) == null ? undefined : f,
    legendId: jspb.Message.getFieldWithDefault(msg, 30, ""),
    legendVersion: jspb.Message.getFieldWithDefault(msg, 31, 0),
    ratingSubmitted: (f = msg.getRatingSubmitted()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    total: (f = msg.getTotal()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    scopeChangeStatus: jspb.Message.getFieldWithDefault(msg, 34, 0),
    isRequestedPro: (f = msg.getIsRequestedPro()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SearchableJob}
 */
proto.worklayer.internal.v1.SearchableJob.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SearchableJob;
  return proto.worklayer.internal.v1.SearchableJob.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SearchableJob} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SearchableJob}
 */
proto.worklayer.internal.v1.SearchableJob.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegendName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientTeamName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientTeamId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProTeamName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setProTeamId(value);
      break;
    case 9:
      var value = /** @type {!proto.worklayer.internal.v1.Resolution} */ (reader.readEnum());
      msg.setResolution(value);
      break;
    case 10:
      var value = /** @type {!proto.worklayer.internal.v1.WaitingOn} */ (reader.readEnum());
      msg.setWaitingOn(value);
      break;
    case 11:
      var value = /** @type {!proto.worklayer.internal.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceName(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCreated(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateSubmitted(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateDeadline(value);
      break;
    case 16:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCompleted(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateClaimed(value);
      break;
    case 18:
      var value = new proto.worklayer.internal.v1.Milestone;
      reader.readMessage(value,proto.worklayer.internal.v1.Milestone.deserializeBinaryFromReader);
      msg.addMilestones(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addJobSpecs(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 21:
      var value = new proto.worklayer.internal.v1.Member;
      reader.readMessage(value,proto.worklayer.internal.v1.Member.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 22:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProviderCutAmount(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setConversationId(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArchived(value);
      break;
    case 25:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateModified(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateLastActivity(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 28:
      var value = /** @type {!proto.worklayer.internal.v1.JobProgressionStepStatus} */ (reader.readEnum());
      msg.setProgressionStep(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.addJobScopeItems(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegendId(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLegendVersion(value);
      break;
    case 32:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setRatingSubmitted(value);
      break;
    case 33:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotal(value);
      break;
    case 34:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setScopeChangeStatus(value);
      break;
    case 35:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsRequestedPro(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SearchableJob.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SearchableJob} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SearchableJob.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getShortId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLegendName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getClientTeamName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getClientTeamId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProTeamName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getProTeamId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getResolution();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getWaitingOn();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getWorkspaceName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDateCreated();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateSubmitted();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateDeadline();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateCompleted();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateClaimed();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMilestonesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.worklayer.internal.v1.Milestone.serializeBinaryToWriter
    );
  }
  f = message.getJobSpecsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      proto.worklayer.internal.v1.Member.serializeBinaryToWriter
    );
  }
  f = message.getProviderCutAmount();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getConversationId();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getArchived();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getDateModified();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateLastActivity();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getProgressionStep();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
  f = message.getJobScopeItemsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      29,
      f
    );
  }
  f = message.getLegendId();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getLegendVersion();
  if (f !== 0) {
    writer.writeInt32(
      31,
      f
    );
  }
  f = message.getRatingSubmitted();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getScopeChangeStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      34,
      f
    );
  }
  f = message.getIsRequestedPro();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string short_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getShortId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setShortId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string legend_name = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getLegendName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setLegendName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string client_team_name = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getClientTeamName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setClientTeamName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string client_team_id = 6;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getClientTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setClientTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string pro_team_name = 7;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getProTeamName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setProTeamName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string pro_team_id = 8;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getProTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setProTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional Resolution resolution = 9;
 * @return {!proto.worklayer.internal.v1.Resolution}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getResolution = function() {
  return /** @type {!proto.worklayer.internal.v1.Resolution} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Resolution} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setResolution = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional WaitingOn waiting_on = 10;
 * @return {!proto.worklayer.internal.v1.WaitingOn}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getWaitingOn = function() {
  return /** @type {!proto.worklayer.internal.v1.WaitingOn} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.WaitingOn} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setWaitingOn = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional Status status = 11;
 * @return {!proto.worklayer.internal.v1.Status}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Status} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string workspace_name = 12;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getWorkspaceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setWorkspaceName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional google.protobuf.Timestamp date_created = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getDateCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setDateCreated = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearDateCreated = function() {
  return this.setDateCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasDateCreated = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Timestamp date_submitted = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getDateSubmitted = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setDateSubmitted = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearDateSubmitted = function() {
  return this.setDateSubmitted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasDateSubmitted = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp date_deadline = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getDateDeadline = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setDateDeadline = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearDateDeadline = function() {
  return this.setDateDeadline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasDateDeadline = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.Timestamp date_completed = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getDateCompleted = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setDateCompleted = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearDateCompleted = function() {
  return this.setDateCompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasDateCompleted = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.Timestamp date_claimed = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getDateClaimed = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setDateClaimed = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearDateClaimed = function() {
  return this.setDateClaimed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasDateClaimed = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated Milestone milestones = 18;
 * @return {!Array<!proto.worklayer.internal.v1.Milestone>}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getMilestonesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Milestone>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Milestone, 18));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Milestone>} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setMilestonesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Milestone=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Milestone}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.addMilestones = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.worklayer.internal.v1.Milestone, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearMilestonesList = function() {
  return this.setMilestonesList([]);
};


/**
 * repeated string job_specs = 19;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getJobSpecsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setJobSpecsList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.addJobSpecs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearJobSpecsList = function() {
  return this.setJobSpecsList([]);
};


/**
 * optional string workspace_id = 20;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * repeated Member members = 21;
 * @return {!Array<!proto.worklayer.internal.v1.Member>}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Member>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Member, 21));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Member>} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Member=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Member}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.worklayer.internal.v1.Member, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * optional worklayer.shared.types.v1.Decimal provider_cut_amount = 22;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getProviderCutAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 22));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setProviderCutAmount = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearProviderCutAmount = function() {
  return this.setProviderCutAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasProviderCutAmount = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.StringValue conversation_id = 23;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getConversationId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 23));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setConversationId = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearConversationId = function() {
  return this.setConversationId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasConversationId = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional bool archived = 24;
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional google.protobuf.Timestamp date_modified = 25;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getDateModified = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 25));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setDateModified = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearDateModified = function() {
  return this.setDateModified(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasDateModified = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.Timestamp date_last_activity = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getDateLastActivity = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setDateLastActivity = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearDateLastActivity = function() {
  return this.setDateLastActivity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasDateLastActivity = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional string description = 27;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional JobProgressionStepStatus progression_step = 28;
 * @return {!proto.worklayer.internal.v1.JobProgressionStepStatus}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getProgressionStep = function() {
  return /** @type {!proto.worklayer.internal.v1.JobProgressionStepStatus} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionStepStatus} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setProgressionStep = function(value) {
  return jspb.Message.setProto3EnumField(this, 28, value);
};


/**
 * repeated string job_scope_items = 29;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getJobScopeItemsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 29));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setJobScopeItemsList = function(value) {
  return jspb.Message.setField(this, 29, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.addJobScopeItems = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 29, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearJobScopeItemsList = function() {
  return this.setJobScopeItemsList([]);
};


/**
 * optional string legend_id = 30;
 * @return {string}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getLegendId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setLegendId = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional int32 legend_version = 31;
 * @return {number}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getLegendVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setLegendVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal rating_submitted = 32;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getRatingSubmitted = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 32));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setRatingSubmitted = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearRatingSubmitted = function() {
  return this.setRatingSubmitted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasRatingSubmitted = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal total = 33;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getTotal = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 33));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setTotal = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearTotal = function() {
  return this.setTotal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasTotal = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional JobScopeChangeStatus scope_change_status = 34;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getScopeChangeStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.setScopeChangeStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 34, value);
};


/**
 * optional google.protobuf.BoolValue is_requested_pro = 35;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.getIsRequestedPro = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 35));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
*/
proto.worklayer.internal.v1.SearchableJob.prototype.setIsRequestedPro = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SearchableJob} returns this
 */
proto.worklayer.internal.v1.SearchableJob.prototype.clearIsRequestedPro = function() {
  return this.setIsRequestedPro(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SearchableJob.prototype.hasIsRequestedPro = function() {
  return jspb.Message.getField(this, 35) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Member.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Member.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Member} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Member.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    picture: jspb.Message.getFieldWithDefault(msg, 3, ""),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    role: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Member}
 */
proto.worklayer.internal.v1.Member.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Member;
  return proto.worklayer.internal.v1.Member.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Member} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Member}
 */
proto.worklayer.internal.v1.Member.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPicture(value);
      break;
    case 4:
      var value = /** @type {!proto.worklayer.internal.v1.MemberType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {!proto.worklayer.internal.v1.MemberRoleType} */ (reader.readEnum());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Member.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Member.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Member} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Member.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPicture();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Member.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Member} returns this
 */
proto.worklayer.internal.v1.Member.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Member.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Member} returns this
 */
proto.worklayer.internal.v1.Member.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string picture = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.Member.prototype.getPicture = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Member} returns this
 */
proto.worklayer.internal.v1.Member.prototype.setPicture = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional MemberType type = 4;
 * @return {!proto.worklayer.internal.v1.MemberType}
 */
proto.worklayer.internal.v1.Member.prototype.getType = function() {
  return /** @type {!proto.worklayer.internal.v1.MemberType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.MemberType} value
 * @return {!proto.worklayer.internal.v1.Member} returns this
 */
proto.worklayer.internal.v1.Member.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional MemberRoleType role = 5;
 * @return {!proto.worklayer.internal.v1.MemberRoleType}
 */
proto.worklayer.internal.v1.Member.prototype.getRole = function() {
  return /** @type {!proto.worklayer.internal.v1.MemberRoleType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.MemberRoleType} value
 * @return {!proto.worklayer.internal.v1.Member} returns this
 */
proto.worklayer.internal.v1.Member.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Job.repeatedFields_ = [3,8,16,19,21,24,25,31,39,40,46,48,50,52,53,58];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shortId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    jobSpecsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    conversationId: (f = msg.getConversationId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    legend: (f = msg.getLegend()) && proto.worklayer.internal.v1.Job.Legend.toObject(includeInstance, f),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.worklayer.internal.v1.Job.Member.toObject, includeInstance),
    dateAccepted: (f = msg.getDateAccepted()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateCreated: (f = msg.getDateCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateModified: (f = msg.getDateModified()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateTransmitted: (f = msg.getDateTransmitted()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateStart: (f = msg.getDateStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateClosed: (f = msg.getDateClosed()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    providerCutAmount: (f = msg.getProviderCutAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    couponCodesList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
    status: jspb.Message.getFieldWithDefault(msg, 17, 0),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 18, ""),
    milestonesList: jspb.Message.toObjectList(msg.getMilestonesList(),
    proto.worklayer.internal.v1.Job.Milestone.toObject, includeInstance),
    ownerTeamId: (f = msg.getOwnerTeamId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    teamIdsList: (f = jspb.Message.getRepeatedField(msg, 21)) == null ? undefined : f,
    requestedProId: (f = msg.getRequestedProId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    requestedProPublicId: (f = msg.getRequestedProPublicId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    infoLinesList: jspb.Message.toObjectList(msg.getInfoLinesList(),
    proto.worklayer.internal.v1.Job.InfoLine.toObject, includeInstance),
    answersList: jspb.Message.toObjectList(msg.getAnswersList(),
    proto.worklayer.internal.v1.Job.Answer.toObject, includeInstance),
    resolution: jspb.Message.getFieldWithDefault(msg, 26, 0),
    ratingReceived: (f = msg.getRatingReceived()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    ratingReceivedComment: (f = msg.getRatingReceivedComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    ratingSubmitted: (f = msg.getRatingSubmitted()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    ratingSubmittedComment: (f = msg.getRatingSubmittedComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    ratingSubmittedCategoriesList: (f = jspb.Message.getRepeatedField(msg, 31)) == null ? undefined : f,
    paidAmount: (f = msg.getPaidAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    total: (f = msg.getTotal()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    paymentInfoStatus: jspb.Message.getFieldWithDefault(msg, 34, 0),
    waitingOn: jspb.Message.getFieldWithDefault(msg, 35, 0),
    dateDeadline: (f = msg.getDateDeadline()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    archived: jspb.Message.getBooleanFieldWithDefault(msg, 37, false),
    couponAmount: (f = msg.getCouponAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    jobScopeItemsList: jspb.Message.toObjectList(msg.getJobScopeItemsList(),
    proto.worklayer.internal.v1.Job.JobScopeItem.toObject, includeInstance),
    amendmentsList: jspb.Message.toObjectList(msg.getAmendmentsList(),
    proto.worklayer.internal.v1.Job.Amendment.toObject, includeInstance),
    dateLastActivity: (f = msg.getDateLastActivity()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    payoutSplit: (f = msg.getPayoutSplit()) && proto.worklayer.internal.v1.Job.PayoutSplit.toObject(includeInstance, f),
    callingActorAllocation: (f = msg.getCallingActorAllocation()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    primaryAmount: (f = msg.getPrimaryAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    adminFeeAmount: (f = msg.getAdminFeeAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    stripeChargesList: (f = jspb.Message.getRepeatedField(msg, 46)) == null ? undefined : f,
    billingType: jspb.Message.getFieldWithDefault(msg, 47, 0),
    coverageStatesList: (f = jspb.Message.getRepeatedField(msg, 48)) == null ? undefined : f,
    resolutionReason: jspb.Message.getFieldWithDefault(msg, 49, ""),
    yearsList: (f = jspb.Message.getRepeatedField(msg, 50)) == null ? undefined : f,
    amendedAmount: (f = msg.getAmendedAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    couponIdsList: (f = jspb.Message.getRepeatedField(msg, 52)) == null ? undefined : f,
    ratingReceivedCategoriesList: (f = jspb.Message.getRepeatedField(msg, 53)) == null ? undefined : f,
    dateReopened: (f = msg.getDateReopened()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateLastStale: (f = msg.getDateLastStale()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    stale: jspb.Message.getBooleanFieldWithDefault(msg, 56, false),
    stripePayoutsList: (f = jspb.Message.getRepeatedField(msg, 58)) == null ? undefined : f,
    currentMilestoneId: jspb.Message.getFieldWithDefault(msg, 59, ""),
    consultation: (f = msg.getConsultation()) && internal_consultation_pb.Consultation.toObject(includeInstance, f),
    progressionStep: jspb.Message.getFieldWithDefault(msg, 61, 0),
    scopeChangeStatus: jspb.Message.getFieldWithDefault(msg, 62, 0),
    purgeStatus: jspb.Message.getFieldWithDefault(msg, 63, 0),
    deprecatedJobType: jspb.Message.getFieldWithDefault(msg, 64, 0),
    type: (f = msg.getType()) && proto.worklayer.internal.v1.Job.JobType.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job}
 */
proto.worklayer.internal.v1.Job.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job;
  return proto.worklayer.internal.v1.Job.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job}
 */
proto.worklayer.internal.v1.Job.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addJobSpecs(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setConversationId(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 7:
      var value = new proto.worklayer.internal.v1.Job.Legend;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Legend.deserializeBinaryFromReader);
      msg.setLegend(value);
      break;
    case 8:
      var value = new proto.worklayer.internal.v1.Job.Member;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Member.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateAccepted(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCreated(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateModified(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateTransmitted(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateStart(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateClosed(value);
      break;
    case 15:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProviderCutAmount(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.addCouponCodes(value);
      break;
    case 17:
      var value = /** @type {!proto.worklayer.internal.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 19:
      var value = new proto.worklayer.internal.v1.Job.Milestone;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Milestone.deserializeBinaryFromReader);
      msg.addMilestones(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOwnerTeamId(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.addTeamIds(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRequestedProId(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRequestedProPublicId(value);
      break;
    case 24:
      var value = new proto.worklayer.internal.v1.Job.InfoLine;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.InfoLine.deserializeBinaryFromReader);
      msg.addInfoLines(value);
      break;
    case 25:
      var value = new proto.worklayer.internal.v1.Job.Answer;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Answer.deserializeBinaryFromReader);
      msg.addAnswers(value);
      break;
    case 26:
      var value = /** @type {!proto.worklayer.internal.v1.Resolution} */ (reader.readEnum());
      msg.setResolution(value);
      break;
    case 27:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setRatingReceived(value);
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRatingReceivedComment(value);
      break;
    case 29:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setRatingSubmitted(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRatingSubmittedComment(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.addRatingSubmittedCategories(value);
      break;
    case 32:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPaidAmount(value);
      break;
    case 33:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotal(value);
      break;
    case 34:
      var value = /** @type {!proto.worklayer.internal.v1.Job.PaymentInfoStatus} */ (reader.readEnum());
      msg.setPaymentInfoStatus(value);
      break;
    case 35:
      var value = /** @type {!proto.worklayer.internal.v1.WaitingOn} */ (reader.readEnum());
      msg.setWaitingOn(value);
      break;
    case 36:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateDeadline(value);
      break;
    case 37:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArchived(value);
      break;
    case 38:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setCouponAmount(value);
      break;
    case 39:
      var value = new proto.worklayer.internal.v1.Job.JobScopeItem;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.JobScopeItem.deserializeBinaryFromReader);
      msg.addJobScopeItems(value);
      break;
    case 40:
      var value = new proto.worklayer.internal.v1.Job.Amendment;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Amendment.deserializeBinaryFromReader);
      msg.addAmendments(value);
      break;
    case 41:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateLastActivity(value);
      break;
    case 42:
      var value = new proto.worklayer.internal.v1.Job.PayoutSplit;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.PayoutSplit.deserializeBinaryFromReader);
      msg.setPayoutSplit(value);
      break;
    case 43:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setCallingActorAllocation(value);
      break;
    case 44:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrimaryAmount(value);
      break;
    case 45:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setAdminFeeAmount(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.addStripeCharges(value);
      break;
    case 47:
      var value = /** @type {!proto.worklayer.internal.v1.Job.BillingType} */ (reader.readEnum());
      msg.setBillingType(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.addCoverageStates(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setResolutionReason(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.addYears(value);
      break;
    case 51:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setAmendedAmount(value);
      break;
    case 52:
      var value = /** @type {string} */ (reader.readString());
      msg.addCouponIds(value);
      break;
    case 53:
      var value = /** @type {string} */ (reader.readString());
      msg.addRatingReceivedCategories(value);
      break;
    case 54:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateReopened(value);
      break;
    case 55:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateLastStale(value);
      break;
    case 56:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStale(value);
      break;
    case 58:
      var value = /** @type {string} */ (reader.readString());
      msg.addStripePayouts(value);
      break;
    case 59:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentMilestoneId(value);
      break;
    case 60:
      var value = new internal_consultation_pb.Consultation;
      reader.readMessage(value,internal_consultation_pb.Consultation.deserializeBinaryFromReader);
      msg.setConsultation(value);
      break;
    case 61:
      var value = /** @type {!proto.worklayer.internal.v1.JobProgressionStepStatus} */ (reader.readEnum());
      msg.setProgressionStep(value);
      break;
    case 62:
      var value = /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (reader.readEnum());
      msg.setScopeChangeStatus(value);
      break;
    case 63:
      var value = /** @type {!proto.worklayer.internal.v1.PurgeStatus} */ (reader.readEnum());
      msg.setPurgeStatus(value);
      break;
    case 64:
      var value = /** @type {!proto.worklayer.internal.v1.Job.DeprecatedJobType} */ (reader.readEnum());
      msg.setDeprecatedJobType(value);
      break;
    case 65:
      var value = new proto.worklayer.internal.v1.Job.JobType;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.JobType.deserializeBinaryFromReader);
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShortId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getJobSpecsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getConversationId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLegend();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.worklayer.internal.v1.Job.Legend.serializeBinaryToWriter
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.worklayer.internal.v1.Job.Member.serializeBinaryToWriter
    );
  }
  f = message.getDateAccepted();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateCreated();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateModified();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateTransmitted();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateStart();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateClosed();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProviderCutAmount();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getCouponCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      16,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getMilestonesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      proto.worklayer.internal.v1.Job.Milestone.serializeBinaryToWriter
    );
  }
  f = message.getOwnerTeamId();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTeamIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      21,
      f
    );
  }
  f = message.getRequestedProId();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRequestedProPublicId();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getInfoLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      24,
      f,
      proto.worklayer.internal.v1.Job.InfoLine.serializeBinaryToWriter
    );
  }
  f = message.getAnswersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      25,
      f,
      proto.worklayer.internal.v1.Job.Answer.serializeBinaryToWriter
    );
  }
  f = message.getResolution();
  if (f !== 0.0) {
    writer.writeEnum(
      26,
      f
    );
  }
  f = message.getRatingReceived();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getRatingReceivedComment();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRatingSubmitted();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getRatingSubmittedComment();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRatingSubmittedCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      31,
      f
    );
  }
  f = message.getPaidAmount();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getPaymentInfoStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      34,
      f
    );
  }
  f = message.getWaitingOn();
  if (f !== 0.0) {
    writer.writeEnum(
      35,
      f
    );
  }
  f = message.getDateDeadline();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getArchived();
  if (f) {
    writer.writeBool(
      37,
      f
    );
  }
  f = message.getCouponAmount();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getJobScopeItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      39,
      f,
      proto.worklayer.internal.v1.Job.JobScopeItem.serializeBinaryToWriter
    );
  }
  f = message.getAmendmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      40,
      f,
      proto.worklayer.internal.v1.Job.Amendment.serializeBinaryToWriter
    );
  }
  f = message.getDateLastActivity();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPayoutSplit();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      proto.worklayer.internal.v1.Job.PayoutSplit.serializeBinaryToWriter
    );
  }
  f = message.getCallingActorAllocation();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getPrimaryAmount();
  if (f != null) {
    writer.writeMessage(
      44,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getAdminFeeAmount();
  if (f != null) {
    writer.writeMessage(
      45,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getStripeChargesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      46,
      f
    );
  }
  f = message.getBillingType();
  if (f !== 0.0) {
    writer.writeEnum(
      47,
      f
    );
  }
  f = message.getCoverageStatesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      48,
      f
    );
  }
  f = message.getResolutionReason();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
  f = message.getYearsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      50,
      f
    );
  }
  f = message.getAmendedAmount();
  if (f != null) {
    writer.writeMessage(
      51,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getCouponIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      52,
      f
    );
  }
  f = message.getRatingReceivedCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      53,
      f
    );
  }
  f = message.getDateReopened();
  if (f != null) {
    writer.writeMessage(
      54,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateLastStale();
  if (f != null) {
    writer.writeMessage(
      55,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStale();
  if (f) {
    writer.writeBool(
      56,
      f
    );
  }
  f = message.getStripePayoutsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      58,
      f
    );
  }
  f = message.getCurrentMilestoneId();
  if (f.length > 0) {
    writer.writeString(
      59,
      f
    );
  }
  f = message.getConsultation();
  if (f != null) {
    writer.writeMessage(
      60,
      f,
      internal_consultation_pb.Consultation.serializeBinaryToWriter
    );
  }
  f = message.getProgressionStep();
  if (f !== 0.0) {
    writer.writeEnum(
      61,
      f
    );
  }
  f = message.getScopeChangeStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      62,
      f
    );
  }
  f = message.getPurgeStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      63,
      f
    );
  }
  f = message.getDeprecatedJobType();
  if (f !== 0.0) {
    writer.writeEnum(
      64,
      f
    );
  }
  f = message.getType();
  if (f != null) {
    writer.writeMessage(
      65,
      f,
      proto.worklayer.internal.v1.Job.JobType.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Job.PaymentInfoStatus = {
  NOT_PROVIDED: 0,
  REQUESTED: 1,
  PROVIDED: 2
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Job.BillingType = {
  EXTERNAL: 0,
  STRIPE: 1
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Job.MemberType = {
  CLIENT: 0,
  PROVIDER: 1
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Job.MemberRole = {
  CHAMPION: 0,
  SUPPORTING: 1
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Job.DeprecatedJobType = {
  JOB_TYPE_UNSPECIFIED: 0,
  LEGACY: 1,
  BOOKKEEPING: 2,
  CONSULTATION: 3,
  MISC: 4,
  TAX: 5
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.JobScopeItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.JobScopeItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobScopeItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    price: (f = msg.getPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    proPrice: (f = msg.getProPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    quantity: jspb.Message.getFieldWithDefault(msg, 6, 0),
    inventoryItemId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    inventoryItemVersionId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    bundleId: (f = msg.getBundleId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    customItemId: (f = msg.getCustomItemId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    deprecatedCourtesyQuantity: jspb.Message.getFieldWithDefault(msg, 11, 0),
    courtesyQuantity: (f = msg.getCourtesyQuantity()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.JobScopeItem;
  return proto.worklayer.internal.v1.Job.JobScopeItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.JobScopeItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 5:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryItemId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryItemVersionId(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBundleId(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomItemId(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDeprecatedCourtesyQuantity(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setCourtesyQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.JobScopeItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.JobScopeItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobScopeItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getInventoryItemId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getInventoryItemVersionId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getBundleId();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomItemId();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDeprecatedCourtesyQuantity();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getCourtesyQuantity();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal price = 4;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 4));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
*/
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal pro_price = 5;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getProPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 5));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
*/
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setProPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.clearProPrice = function() {
  return this.setProPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.hasProPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 quantity = 6;
 * @return {number}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string inventory_item_id = 7;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getInventoryItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setInventoryItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string inventory_item_version_id = 8;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getInventoryItemVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setInventoryItemVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.StringValue bundle_id = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getBundleId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
*/
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setBundleId = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.clearBundleId = function() {
  return this.setBundleId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.hasBundleId = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue custom_item_id = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getCustomItemId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
*/
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setCustomItemId = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.clearCustomItemId = function() {
  return this.setCustomItemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.hasCustomItemId = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional int32 deprecated_courtesy_quantity = 11;
 * @return {number}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getDeprecatedCourtesyQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setDeprecatedCourtesyQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional google.protobuf.Int32Value courtesy_quantity = 12;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.getCourtesyQuantity = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 12));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
*/
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.setCourtesyQuantity = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.clearCourtesyQuantity = function() {
  return this.setCourtesyQuantity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobScopeItem.prototype.hasCourtesyQuantity = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Amendment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Amendment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Amendment.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 1, ""),
    internalNote: jspb.Message.getFieldWithDefault(msg, 2, ""),
    customerAmount: (f = msg.getCustomerAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    providerAmount: (f = msg.getProviderAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    visibility: jspb.Message.getFieldWithDefault(msg, 5, 0),
    creator: (f = msg.getCreator()) && proto.worklayer.internal.v1.Job.Member.toObject(includeInstance, f),
    dateCreated: (f = msg.getDateCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Amendment}
 */
proto.worklayer.internal.v1.Job.Amendment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Amendment;
  return proto.worklayer.internal.v1.Job.Amendment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Amendment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Amendment}
 */
proto.worklayer.internal.v1.Job.Amendment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInternalNote(value);
      break;
    case 3:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setCustomerAmount(value);
      break;
    case 4:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProviderAmount(value);
      break;
    case 5:
      var value = /** @type {!proto.worklayer.internal.v1.AmendmentVisibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.Job.Member;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Member.deserializeBinaryFromReader);
      msg.setCreator(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Amendment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Amendment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Amendment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInternalNote();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCustomerAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getProviderAmount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCreator();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.v1.Job.Member.serializeBinaryToWriter
    );
  }
  f = message.getDateCreated();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string internal_note = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.getInternalNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.setInternalNote = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal customer_amount = 3;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.getCustomerAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 3));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
*/
proto.worklayer.internal.v1.Job.Amendment.prototype.setCustomerAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.clearCustomerAmount = function() {
  return this.setCustomerAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.hasCustomerAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal provider_amount = 4;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.getProviderAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 4));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
*/
proto.worklayer.internal.v1.Job.Amendment.prototype.setProviderAmount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.clearProviderAmount = function() {
  return this.setProviderAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.hasProviderAmount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AmendmentVisibility visibility = 5;
 * @return {!proto.worklayer.internal.v1.AmendmentVisibility}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.getVisibility = function() {
  return /** @type {!proto.worklayer.internal.v1.AmendmentVisibility} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.AmendmentVisibility} value
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Member creator = 6;
 * @return {?proto.worklayer.internal.v1.Job.Member}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.getCreator = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.Member} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.Member, 6));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.Member|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
*/
proto.worklayer.internal.v1.Job.Amendment.prototype.setCreator = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.clearCreator = function() {
  return this.setCreator(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.hasCreator = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp date_created = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.getDateCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
*/
proto.worklayer.internal.v1.Job.Amendment.prototype.setDateCreated = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Amendment} returns this
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.clearDateCreated = function() {
  return this.setDateCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Amendment.prototype.hasDateCreated = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Member.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Member.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Member} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Member.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    role: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    familyName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    givenName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    picture: jspb.Message.getFieldWithDefault(msg, 7, ""),
    id: jspb.Message.getFieldWithDefault(msg, 8, ""),
    teamId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Member}
 */
proto.worklayer.internal.v1.Job.Member.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Member;
  return proto.worklayer.internal.v1.Job.Member.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Member} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Member}
 */
proto.worklayer.internal.v1.Job.Member.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.worklayer.internal.v1.Job.MemberType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.Job.MemberRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setGivenName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPicture(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Member.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Member.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Member} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Member.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFamilyName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getGivenName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPicture();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional MemberType type = 1;
 * @return {!proto.worklayer.internal.v1.Job.MemberType}
 */
proto.worklayer.internal.v1.Job.Member.prototype.getType = function() {
  return /** @type {!proto.worklayer.internal.v1.Job.MemberType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Job.MemberType} value
 * @return {!proto.worklayer.internal.v1.Job.Member} returns this
 */
proto.worklayer.internal.v1.Job.Member.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional MemberRole role = 2;
 * @return {!proto.worklayer.internal.v1.Job.MemberRole}
 */
proto.worklayer.internal.v1.Job.Member.prototype.getRole = function() {
  return /** @type {!proto.worklayer.internal.v1.Job.MemberRole} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Job.MemberRole} value
 * @return {!proto.worklayer.internal.v1.Job.Member} returns this
 */
proto.worklayer.internal.v1.Job.Member.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Member.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Member} returns this
 */
proto.worklayer.internal.v1.Job.Member.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Member.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Member} returns this
 */
proto.worklayer.internal.v1.Job.Member.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string family_name = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Member.prototype.getFamilyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Member} returns this
 */
proto.worklayer.internal.v1.Job.Member.prototype.setFamilyName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string given_name = 6;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Member.prototype.getGivenName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Member} returns this
 */
proto.worklayer.internal.v1.Job.Member.prototype.setGivenName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string picture = 7;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Member.prototype.getPicture = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Member} returns this
 */
proto.worklayer.internal.v1.Job.Member.prototype.setPicture = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string id = 8;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Member.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Member} returns this
 */
proto.worklayer.internal.v1.Job.Member.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string team_id = 9;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Member.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Member} returns this
 */
proto.worklayer.internal.v1.Job.Member.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string user_id = 10;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Member.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Member} returns this
 */
proto.worklayer.internal.v1.Job.Member.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Legend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Legend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    version: jspb.Message.getFieldWithDefault(msg, 3, 0),
    allowScheduling: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    billingConfig: (f = msg.getBillingConfig()) && proto.worklayer.internal.v1.Job.Legend.BillingConfig.toObject(includeInstance, f),
    ratingConfig: (f = msg.getRatingConfig()) && proto.worklayer.internal.v1.Job.Legend.RatingConfig.toObject(includeInstance, f),
    priceUnit: (f = msg.getPriceUnit()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    excludeLegacyStates: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    excludeLegacyYears: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    deadlineConfig: (f = msg.getDeadlineConfig()) && proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.toObject(includeInstance, f),
    skipBilling: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    skipQuote: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    allowProSelection: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    alwaysEnableVoiceCall: jspb.Message.getBooleanFieldWithDefault(msg, 14, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Legend}
 */
proto.worklayer.internal.v1.Job.Legend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Legend;
  return proto.worklayer.internal.v1.Job.Legend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Legend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Legend}
 */
proto.worklayer.internal.v1.Job.Legend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowScheduling(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.Job.Legend.BillingConfig;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Legend.BillingConfig.deserializeBinaryFromReader);
      msg.setBillingConfig(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.Job.Legend.RatingConfig;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Legend.RatingConfig.deserializeBinaryFromReader);
      msg.setRatingConfig(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPriceUnit(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExcludeLegacyStates(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExcludeLegacyYears(value);
      break;
    case 10:
      var value = new proto.worklayer.internal.v1.Job.Legend.DeadlineConfig;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.deserializeBinaryFromReader);
      msg.setDeadlineConfig(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkipBilling(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkipQuote(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowProSelection(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlwaysEnableVoiceCall(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Legend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Legend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAllowScheduling();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getBillingConfig();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.Job.Legend.BillingConfig.serializeBinaryToWriter
    );
  }
  f = message.getRatingConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.v1.Job.Legend.RatingConfig.serializeBinaryToWriter
    );
  }
  f = message.getPriceUnit();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getExcludeLegacyStates();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getExcludeLegacyYears();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDeadlineConfig();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.serializeBinaryToWriter
    );
  }
  f = message.getSkipBilling();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getSkipQuote();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getAllowProSelection();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getAlwaysEnableVoiceCall();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Legend.DeadlineConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    expr: (f = msg.getExpr()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Legend.DeadlineConfig}
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Legend.DeadlineConfig;
  return proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Legend.DeadlineConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Legend.DeadlineConfig}
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setExpr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Legend.DeadlineConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getExpr();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.DeadlineConfig} returns this
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue expr = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.prototype.getExpr = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.DeadlineConfig} returns this
*/
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.prototype.setExpr = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Legend.DeadlineConfig} returns this
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.prototype.clearExpr = function() {
  return this.setExpr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.DeadlineConfig.prototype.hasExpr = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Legend.BillingConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Legend.BillingConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    allowManualPaymentCollection: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    deferPaymentInfoCollection: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Legend.BillingConfig}
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Legend.BillingConfig;
  return proto.worklayer.internal.v1.Job.Legend.BillingConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Legend.BillingConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Legend.BillingConfig}
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowManualPaymentCollection(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeferPaymentInfoCollection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Legend.BillingConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Legend.BillingConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllowManualPaymentCollection();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getDeferPaymentInfoCollection();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool allow_manual_payment_collection = 1;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig.prototype.getAllowManualPaymentCollection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.BillingConfig} returns this
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig.prototype.setAllowManualPaymentCollection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool defer_payment_info_collection = 2;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig.prototype.getDeferPaymentInfoCollection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.BillingConfig} returns this
 */
proto.worklayer.internal.v1.Job.Legend.BillingConfig.prototype.setDeferPaymentInfoCollection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Legend.RatingConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    disabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    starRatingDisabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    sourcesList: jspb.Message.toObjectList(msg.getSourcesList(),
    proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.toObject, includeInstance),
    platformRatingEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    proRatingEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    customerRatingMethod: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Legend.RatingConfig;
  return proto.worklayer.internal.v1.Job.Legend.RatingConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStarRatingDisabled(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.deserializeBinaryFromReader);
      msg.addSources(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlatformRatingEnabled(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProRatingEnabled(value);
      break;
    case 6:
      var value = /** @type {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.CustomerRatingMethod} */ (reader.readEnum());
      msg.setCustomerRatingMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Legend.RatingConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getStarRatingDisabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getSourcesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.serializeBinaryToWriter
    );
  }
  f = message.getPlatformRatingEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getProRatingEnabled();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCustomerRatingMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.CustomerRatingMethod = {
  UNSPECIFIED: 0,
  THUMBS: 1,
  STARS: 2
};


/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.TypeCase = {
  TYPE_NOT_SET: 0,
  EXPLICIT: 1
};

/**
 * @return {proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.TypeCase}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.toObject = function(includeInstance, msg) {
  var f, obj = {
    explicit: (f = msg.getExplicit()) && proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source;
  return proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.deserializeBinaryFromReader);
      msg.setExplicit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExplicit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.toObject = function(includeInstance, msg) {
  var f, obj = {
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit;
  return proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string categories = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.prototype.getCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit} returns this
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit} returns this
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit} returns this
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional Explicit explicit = 1;
 * @return {?proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.prototype.getExplicit = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.Explicit|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source} returns this
*/
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.prototype.setExplicit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source} returns this
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.prototype.clearExplicit = function() {
  return this.setExplicit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source.prototype.hasExplicit = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool disabled = 1;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig} returns this
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.setDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool star_rating_disabled = 2;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.getStarRatingDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig} returns this
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.setStarRatingDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated Source sources = 3;
 * @return {!Array<!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source>}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.getSourcesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source, 3));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source>} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig} returns this
*/
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.setSourcesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.addSources = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.worklayer.internal.v1.Job.Legend.RatingConfig.Source, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig} returns this
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.clearSourcesList = function() {
  return this.setSourcesList([]);
};


/**
 * optional bool platform_rating_enabled = 4;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.getPlatformRatingEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig} returns this
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.setPlatformRatingEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool pro_rating_enabled = 5;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.getProRatingEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig} returns this
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.setProRatingEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional CustomerRatingMethod customer_rating_method = 6;
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.CustomerRatingMethod}
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.getCustomerRatingMethod = function() {
  return /** @type {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.CustomerRatingMethod} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Job.Legend.RatingConfig.CustomerRatingMethod} value
 * @return {!proto.worklayer.internal.v1.Job.Legend.RatingConfig} returns this
 */
proto.worklayer.internal.v1.Job.Legend.RatingConfig.prototype.setCustomerRatingMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 version = 3;
 * @return {number}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool allow_scheduling = 4;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getAllowScheduling = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.setAllowScheduling = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional BillingConfig billing_config = 5;
 * @return {?proto.worklayer.internal.v1.Job.Legend.BillingConfig}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getBillingConfig = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.Legend.BillingConfig} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.Legend.BillingConfig, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.Legend.BillingConfig|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
*/
proto.worklayer.internal.v1.Job.Legend.prototype.setBillingConfig = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.clearBillingConfig = function() {
  return this.setBillingConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.hasBillingConfig = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RatingConfig rating_config = 6;
 * @return {?proto.worklayer.internal.v1.Job.Legend.RatingConfig}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getRatingConfig = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.Legend.RatingConfig} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.Legend.RatingConfig, 6));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.Legend.RatingConfig|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
*/
proto.worklayer.internal.v1.Job.Legend.prototype.setRatingConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.clearRatingConfig = function() {
  return this.setRatingConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.hasRatingConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue price_unit = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getPriceUnit = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
*/
proto.worklayer.internal.v1.Job.Legend.prototype.setPriceUnit = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.clearPriceUnit = function() {
  return this.setPriceUnit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.hasPriceUnit = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool exclude_legacy_states = 8;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getExcludeLegacyStates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.setExcludeLegacyStates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool exclude_legacy_years = 9;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getExcludeLegacyYears = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.setExcludeLegacyYears = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional DeadlineConfig deadline_config = 10;
 * @return {?proto.worklayer.internal.v1.Job.Legend.DeadlineConfig}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getDeadlineConfig = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.Legend.DeadlineConfig} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.Legend.DeadlineConfig, 10));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.Legend.DeadlineConfig|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
*/
proto.worklayer.internal.v1.Job.Legend.prototype.setDeadlineConfig = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.clearDeadlineConfig = function() {
  return this.setDeadlineConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.hasDeadlineConfig = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool skip_billing = 11;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getSkipBilling = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.setSkipBilling = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool skip_quote = 12;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getSkipQuote = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.setSkipQuote = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool allow_pro_selection = 13;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getAllowProSelection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.setAllowProSelection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool always_enable_voice_call = 14;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Legend.prototype.getAlwaysEnableVoiceCall = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Legend} returns this
 */
proto.worklayer.internal.v1.Job.Legend.prototype.setAlwaysEnableVoiceCall = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Job.Milestone.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Milestone.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Milestone} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Milestone.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    completed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    tasksList: jspb.Message.toObjectList(msg.getTasksList(),
    proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.toObject, includeInstance),
    description: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Milestone}
 */
proto.worklayer.internal.v1.Job.Milestone.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Milestone;
  return proto.worklayer.internal.v1.Job.Milestone.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Milestone} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Milestone}
 */
proto.worklayer.internal.v1.Job.Milestone.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleted(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.Job.Milestone.MilestoneTask;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.deserializeBinaryFromReader);
      msg.addTasks(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Milestone.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Milestone} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Milestone.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCompleted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    designee: jspb.Message.getFieldWithDefault(msg, 4, 0),
    completedById: (f = msg.getCompletedById()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    completedByPublicId: (f = msg.getCompletedByPublicId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    dateCompleted: (f = msg.getDateCompleted()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    completed: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Milestone.MilestoneTask;
  return proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.TaskDesignee} */ (reader.readEnum());
      msg.setDesignee(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCompletedById(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCompletedByPublicId(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCompleted(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDesignee();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCompletedById();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCompletedByPublicId();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDateCompleted();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCompleted();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.TaskDesignee = {
  CLIENT: 0,
  PROVIDER: 1
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue description = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
*/
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TaskDesignee designee = 4;
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.TaskDesignee}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.getDesignee = function() {
  return /** @type {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.TaskDesignee} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.TaskDesignee} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.setDesignee = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue completed_by_id = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.getCompletedById = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
*/
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.setCompletedById = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.clearCompletedById = function() {
  return this.setCompletedById(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.hasCompletedById = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue completed_by_public_id = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.getCompletedByPublicId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
*/
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.setCompletedByPublicId = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.clearCompletedByPublicId = function() {
  return this.setCompletedByPublicId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.hasCompletedByPublicId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp date_completed = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.getDateCompleted = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
*/
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.setDateCompleted = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.clearDateCompleted = function() {
  return this.setDateCompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.hasDateCompleted = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool completed = 8;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.getCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.MilestoneTask.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool completed = 3;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.getCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated MilestoneTask tasks = 4;
 * @return {!Array<!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask>}
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.getTasksList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Job.Milestone.MilestoneTask, 4));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask>} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone} returns this
*/
proto.worklayer.internal.v1.Job.Milestone.prototype.setTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job.Milestone.MilestoneTask}
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.addTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.worklayer.internal.v1.Job.Milestone.MilestoneTask, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job.Milestone} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.clearTasksList = function() {
  return this.setTasksList([]);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Milestone} returns this
 */
proto.worklayer.internal.v1.Job.Milestone.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.Answer.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.Answer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.Answer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Answer.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.Answer}
 */
proto.worklayer.internal.v1.Job.Answer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.Answer;
  return proto.worklayer.internal.v1.Job.Answer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.Answer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.Answer}
 */
proto.worklayer.internal.v1.Job.Answer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.Answer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.Answer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.Answer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.Answer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Answer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Answer} returns this
 */
proto.worklayer.internal.v1.Job.Answer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.Answer.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.Answer} returns this
 */
proto.worklayer.internal.v1.Job.Answer.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.InfoLine.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.InfoLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.InfoLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.InfoLine.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    content: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.InfoLine}
 */
proto.worklayer.internal.v1.Job.InfoLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.InfoLine;
  return proto.worklayer.internal.v1.Job.InfoLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.InfoLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.InfoLine}
 */
proto.worklayer.internal.v1.Job.InfoLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.InfoLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.InfoLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.InfoLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.InfoLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.InfoLine.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.InfoLine} returns this
 */
proto.worklayer.internal.v1.Job.InfoLine.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.InfoLine.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.InfoLine} returns this
 */
proto.worklayer.internal.v1.Job.InfoLine.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Job.PayoutSplit.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.PayoutSplit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.PayoutSplit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.PayoutSplit.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateAllocatedManually: (f = msg.getDateAllocatedManually()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateAutoAdjusted: (f = msg.getDateAutoAdjusted()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    allocatedManuallyByPublicId: (f = msg.getAllocatedManuallyByPublicId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    autoAdjusted: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    allocationsList: jspb.Message.toObjectList(msg.getAllocationsList(),
    proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.PayoutSplit;
  return proto.worklayer.internal.v1.Job.PayoutSplit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.PayoutSplit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateAllocatedManually(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateAutoAdjusted(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAllocatedManuallyByPublicId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoAdjusted(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.Job.PayoutSplit.Allocation;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.deserializeBinaryFromReader);
      msg.addAllocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.PayoutSplit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.PayoutSplit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.PayoutSplit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateAllocatedManually();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateAutoAdjusted();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAllocatedManuallyByPublicId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAutoAdjusted();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAllocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.toObject = function(includeInstance, msg) {
  var f, obj = {
    userPublicId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: (f = msg.getAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    authorizedPartialPayoutAmount: (f = msg.getAuthorizedPartialPayoutAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.PayoutSplit.Allocation;
  return proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPublicId(value);
      break;
    case 2:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 3:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setAuthorizedPartialPayoutAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getAuthorizedPartialPayoutAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_public_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.getUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation} returns this
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.setUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal amount = 2;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.getAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 2));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation} returns this
*/
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation} returns this
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal authorized_partial_payout_amount = 3;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.getAuthorizedPartialPayoutAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 3));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation} returns this
*/
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.setAuthorizedPartialPayoutAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation} returns this
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.clearAuthorizedPartialPayoutAmount = function() {
  return this.setAuthorizedPartialPayoutAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.Allocation.prototype.hasAuthorizedPartialPayoutAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp date_allocated_manually = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.getDateAllocatedManually = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit} returns this
*/
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.setDateAllocatedManually = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit} returns this
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.clearDateAllocatedManually = function() {
  return this.setDateAllocatedManually(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.hasDateAllocatedManually = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp date_auto_adjusted = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.getDateAutoAdjusted = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit} returns this
*/
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.setDateAutoAdjusted = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit} returns this
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.clearDateAutoAdjusted = function() {
  return this.setDateAutoAdjusted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.hasDateAutoAdjusted = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue allocated_manually_by_public_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.getAllocatedManuallyByPublicId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit} returns this
*/
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.setAllocatedManuallyByPublicId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit} returns this
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.clearAllocatedManuallyByPublicId = function() {
  return this.setAllocatedManuallyByPublicId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.hasAllocatedManuallyByPublicId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool auto_adjusted = 4;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.getAutoAdjusted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit} returns this
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.setAutoAdjusted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * repeated Allocation allocations = 5;
 * @return {!Array<!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation>}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.getAllocationsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Job.PayoutSplit.Allocation, 5));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation>} value
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit} returns this
*/
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.setAllocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit.Allocation}
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.addAllocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.worklayer.internal.v1.Job.PayoutSplit.Allocation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job.PayoutSplit} returns this
 */
proto.worklayer.internal.v1.Job.PayoutSplit.prototype.clearAllocationsList = function() {
  return this.setAllocationsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.Job.JobType.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Job.JobType.TypeCase = {
  TYPE_NOT_SET: 0,
  UNSPECIFIED: 1,
  BOOKKEEPING: 2,
  CONSULTATION: 3,
  TAX: 4,
  MISC: 5
};

/**
 * @return {proto.worklayer.internal.v1.Job.JobType.TypeCase}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.Job.JobType.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.Job.JobType.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.JobType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.JobType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.toObject = function(includeInstance, msg) {
  var f, obj = {
    unspecified: (f = msg.getUnspecified()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
    bookkeeping: (f = msg.getBookkeeping()) && proto.worklayer.internal.v1.Job.JobType.Bookkeeping.toObject(includeInstance, f),
    consultation: (f = msg.getConsultation()) && proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.toObject(includeInstance, f),
    tax: (f = msg.getTax()) && proto.worklayer.internal.v1.Job.JobType.Tax.toObject(includeInstance, f),
    misc: (f = msg.getMisc()) && proto.worklayer.internal.v1.Job.JobType.Misc.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.JobType}
 */
proto.worklayer.internal.v1.Job.JobType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.JobType;
  return proto.worklayer.internal.v1.Job.JobType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.JobType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.JobType}
 */
proto.worklayer.internal.v1.Job.JobType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setUnspecified(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.Job.JobType.Bookkeeping;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.JobType.Bookkeeping.deserializeBinaryFromReader);
      msg.setBookkeeping(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.Job.JobType.ConsultationJobType;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.deserializeBinaryFromReader);
      msg.setConsultation(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.Job.JobType.Tax;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.JobType.Tax.deserializeBinaryFromReader);
      msg.setTax(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.Job.JobType.Misc;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.JobType.Misc.deserializeBinaryFromReader);
      msg.setMisc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.JobType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.JobType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnspecified();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = message.getBookkeeping();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.Job.JobType.Bookkeeping.serializeBinaryToWriter
    );
  }
  f = message.getConsultation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.serializeBinaryToWriter
    );
  }
  f = message.getTax();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.v1.Job.JobType.Tax.serializeBinaryToWriter
    );
  }
  f = message.getMisc();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.Job.JobType.Misc.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.JobType.Bookkeeping.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.JobType.Bookkeeping.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.JobType.Bookkeeping} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.Bookkeeping.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Bookkeeping}
 */
proto.worklayer.internal.v1.Job.JobType.Bookkeeping.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.JobType.Bookkeeping;
  return proto.worklayer.internal.v1.Job.JobType.Bookkeeping.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.JobType.Bookkeeping} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Bookkeeping}
 */
proto.worklayer.internal.v1.Job.JobType.Bookkeeping.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.JobType.Bookkeeping.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.JobType.Bookkeeping.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.JobType.Bookkeeping} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.Bookkeeping.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.JobType.ConsultationJobType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.toObject = function(includeInstance, msg) {
  var f, obj = {
    diyJobId: (f = msg.getDiyJobId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.JobType.ConsultationJobType}
 */
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.JobType.ConsultationJobType;
  return proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.JobType.ConsultationJobType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.JobType.ConsultationJobType}
 */
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDiyJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.JobType.ConsultationJobType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiyJobId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue diy_job_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.prototype.getDiyJobId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobType.ConsultationJobType} returns this
*/
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.prototype.setDiyJobId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobType.ConsultationJobType} returns this
 */
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.prototype.clearDiyJobId = function() {
  return this.setDiyJobId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobType.ConsultationJobType.prototype.hasDiyJobId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.JobType.Tax.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.JobType.Tax} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.Tax.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobLinks: (f = msg.getJobLinks()) && proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.toObject(includeInstance, f),
    isExtensionOnlyJob: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.JobType.Tax;
  return proto.worklayer.internal.v1.Job.JobType.Tax.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.JobType.Tax} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.deserializeBinaryFromReader);
      msg.setJobLinks(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsExtensionOnlyJob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.JobType.Tax.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.JobType.Tax} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.Tax.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobLinks();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.serializeBinaryToWriter
    );
  }
  f = message.getIsExtensionOnlyJob();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TypeCase = {
  TYPE_NOT_SET: 0,
  PREP_JOB_LINK: 1,
  REVIEW_JOB_LINK: 2
};

/**
 * @return {proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TypeCase}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.toObject = function(includeInstance, msg) {
  var f, obj = {
    prepJobLink: (f = msg.getPrepJobLink()) && proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.toObject(includeInstance, f),
    reviewJobLink: (f = msg.getReviewJobLink()) && proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks;
  return proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.deserializeBinaryFromReader);
      msg.setPrepJobLink(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.deserializeBinaryFromReader);
      msg.setReviewJobLink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrepJobLink();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.serializeBinaryToWriter
    );
  }
  f = message.getReviewJobLink();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink;
  return proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink} returns this
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TaxJobLink prep_job_link = 1;
 * @return {?proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.getPrepJobLink = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks} returns this
*/
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.setPrepJobLink = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks} returns this
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.clearPrepJobLink = function() {
  return this.setPrepJobLink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.hasPrepJobLink = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TaxJobLink review_job_link = 2;
 * @return {?proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.getReviewJobLink = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.TaxJobLink|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks} returns this
*/
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.setReviewJobLink = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks} returns this
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.clearReviewJobLink = function() {
  return this.setReviewJobLink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks.prototype.hasReviewJobLink = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TaxJobLinks job_links = 1;
 * @return {?proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.prototype.getJobLinks = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.JobType.Tax.TaxJobLinks|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax} returns this
*/
proto.worklayer.internal.v1.Job.JobType.Tax.prototype.setJobLinks = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax} returns this
 */
proto.worklayer.internal.v1.Job.JobType.Tax.prototype.clearJobLinks = function() {
  return this.setJobLinks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.prototype.hasJobLinks = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool is_extension_only_job = 2;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobType.Tax.prototype.getIsExtensionOnlyJob = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job.JobType.Tax} returns this
 */
proto.worklayer.internal.v1.Job.JobType.Tax.prototype.setIsExtensionOnlyJob = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Job.JobType.Misc.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Job.JobType.Misc.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Job.JobType.Misc} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.Misc.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Misc}
 */
proto.worklayer.internal.v1.Job.JobType.Misc.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Job.JobType.Misc;
  return proto.worklayer.internal.v1.Job.JobType.Misc.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Job.JobType.Misc} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Job.JobType.Misc}
 */
proto.worklayer.internal.v1.Job.JobType.Misc.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Job.JobType.Misc.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Job.JobType.Misc.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Job.JobType.Misc} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Job.JobType.Misc.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional google.protobuf.Empty unspecified = 1;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.getUnspecified = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 1));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobType} returns this
*/
proto.worklayer.internal.v1.Job.JobType.prototype.setUnspecified = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.Job.JobType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobType} returns this
 */
proto.worklayer.internal.v1.Job.JobType.prototype.clearUnspecified = function() {
  return this.setUnspecified(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.hasUnspecified = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Bookkeeping bookkeeping = 2;
 * @return {?proto.worklayer.internal.v1.Job.JobType.Bookkeeping}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.getBookkeeping = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.JobType.Bookkeeping} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.JobType.Bookkeeping, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.JobType.Bookkeeping|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobType} returns this
*/
proto.worklayer.internal.v1.Job.JobType.prototype.setBookkeeping = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.Job.JobType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobType} returns this
 */
proto.worklayer.internal.v1.Job.JobType.prototype.clearBookkeeping = function() {
  return this.setBookkeeping(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.hasBookkeeping = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ConsultationJobType consultation = 3;
 * @return {?proto.worklayer.internal.v1.Job.JobType.ConsultationJobType}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.getConsultation = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.JobType.ConsultationJobType} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.JobType.ConsultationJobType, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.JobType.ConsultationJobType|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobType} returns this
*/
proto.worklayer.internal.v1.Job.JobType.prototype.setConsultation = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.v1.Job.JobType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobType} returns this
 */
proto.worklayer.internal.v1.Job.JobType.prototype.clearConsultation = function() {
  return this.setConsultation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.hasConsultation = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Tax tax = 4;
 * @return {?proto.worklayer.internal.v1.Job.JobType.Tax}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.getTax = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.JobType.Tax} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.JobType.Tax, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.JobType.Tax|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobType} returns this
*/
proto.worklayer.internal.v1.Job.JobType.prototype.setTax = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.worklayer.internal.v1.Job.JobType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobType} returns this
 */
proto.worklayer.internal.v1.Job.JobType.prototype.clearTax = function() {
  return this.setTax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.hasTax = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Misc misc = 5;
 * @return {?proto.worklayer.internal.v1.Job.JobType.Misc}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.getMisc = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.JobType.Misc} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.JobType.Misc, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.JobType.Misc|undefined} value
 * @return {!proto.worklayer.internal.v1.Job.JobType} returns this
*/
proto.worklayer.internal.v1.Job.JobType.prototype.setMisc = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.worklayer.internal.v1.Job.JobType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job.JobType} returns this
 */
proto.worklayer.internal.v1.Job.JobType.prototype.clearMisc = function() {
  return this.setMisc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.JobType.prototype.hasMisc = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string short_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.prototype.getShortId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setShortId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string job_specs = 3;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.prototype.getJobSpecsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setJobSpecsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.addJobSpecs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearJobSpecsList = function() {
  return this.setJobSpecsList([]);
};


/**
 * optional google.protobuf.StringValue conversation_id = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.prototype.getConversationId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setConversationId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearConversationId = function() {
  return this.setConversationId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasConversationId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue description = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue name = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasName = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Legend legend = 7;
 * @return {?proto.worklayer.internal.v1.Job.Legend}
 */
proto.worklayer.internal.v1.Job.prototype.getLegend = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.Legend} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.Legend, 7));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.Legend|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setLegend = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearLegend = function() {
  return this.setLegend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasLegend = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated Member members = 8;
 * @return {!Array<!proto.worklayer.internal.v1.Job.Member>}
 */
proto.worklayer.internal.v1.Job.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Job.Member>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Job.Member, 8));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Job.Member>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Job.Member=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job.Member}
 */
proto.worklayer.internal.v1.Job.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.worklayer.internal.v1.Job.Member, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * optional google.protobuf.Timestamp date_accepted = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.prototype.getDateAccepted = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDateAccepted = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDateAccepted = function() {
  return this.setDateAccepted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDateAccepted = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp date_created = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.prototype.getDateCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDateCreated = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDateCreated = function() {
  return this.setDateCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDateCreated = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp date_modified = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.prototype.getDateModified = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDateModified = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDateModified = function() {
  return this.setDateModified(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDateModified = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp date_transmitted = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.prototype.getDateTransmitted = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDateTransmitted = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDateTransmitted = function() {
  return this.setDateTransmitted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDateTransmitted = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp date_start = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.prototype.getDateStart = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDateStart = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDateStart = function() {
  return this.setDateStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDateStart = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Timestamp date_closed = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.prototype.getDateClosed = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDateClosed = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDateClosed = function() {
  return this.setDateClosed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDateClosed = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal provider_cut_amount = 15;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.prototype.getProviderCutAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 15));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setProviderCutAmount = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearProviderCutAmount = function() {
  return this.setProviderCutAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasProviderCutAmount = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated string coupon_codes = 16;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.prototype.getCouponCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setCouponCodesList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.addCouponCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearCouponCodesList = function() {
  return this.setCouponCodesList([]);
};


/**
 * optional Status status = 17;
 * @return {!proto.worklayer.internal.v1.Status}
 */
proto.worklayer.internal.v1.Job.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Status} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional string workspace_id = 18;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * repeated Milestone milestones = 19;
 * @return {!Array<!proto.worklayer.internal.v1.Job.Milestone>}
 */
proto.worklayer.internal.v1.Job.prototype.getMilestonesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Job.Milestone>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Job.Milestone, 19));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Job.Milestone>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setMilestonesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Job.Milestone=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job.Milestone}
 */
proto.worklayer.internal.v1.Job.prototype.addMilestones = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.worklayer.internal.v1.Job.Milestone, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearMilestonesList = function() {
  return this.setMilestonesList([]);
};


/**
 * optional google.protobuf.StringValue owner_team_id = 20;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.prototype.getOwnerTeamId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 20));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setOwnerTeamId = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearOwnerTeamId = function() {
  return this.setOwnerTeamId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasOwnerTeamId = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * repeated string team_ids = 21;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.prototype.getTeamIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 21));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setTeamIdsList = function(value) {
  return jspb.Message.setField(this, 21, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.addTeamIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 21, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearTeamIdsList = function() {
  return this.setTeamIdsList([]);
};


/**
 * optional google.protobuf.StringValue requested_pro_id = 22;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.prototype.getRequestedProId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 22));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setRequestedProId = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearRequestedProId = function() {
  return this.setRequestedProId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasRequestedProId = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.StringValue requested_pro_public_id = 23;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.prototype.getRequestedProPublicId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 23));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setRequestedProPublicId = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearRequestedProPublicId = function() {
  return this.setRequestedProPublicId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasRequestedProPublicId = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * repeated InfoLine info_lines = 24;
 * @return {!Array<!proto.worklayer.internal.v1.Job.InfoLine>}
 */
proto.worklayer.internal.v1.Job.prototype.getInfoLinesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Job.InfoLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Job.InfoLine, 24));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Job.InfoLine>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setInfoLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 24, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Job.InfoLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job.InfoLine}
 */
proto.worklayer.internal.v1.Job.prototype.addInfoLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 24, opt_value, proto.worklayer.internal.v1.Job.InfoLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearInfoLinesList = function() {
  return this.setInfoLinesList([]);
};


/**
 * repeated Answer answers = 25;
 * @return {!Array<!proto.worklayer.internal.v1.Job.Answer>}
 */
proto.worklayer.internal.v1.Job.prototype.getAnswersList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Job.Answer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Job.Answer, 25));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Job.Answer>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setAnswersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 25, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Job.Answer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job.Answer}
 */
proto.worklayer.internal.v1.Job.prototype.addAnswers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 25, opt_value, proto.worklayer.internal.v1.Job.Answer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearAnswersList = function() {
  return this.setAnswersList([]);
};


/**
 * optional Resolution resolution = 26;
 * @return {!proto.worklayer.internal.v1.Resolution}
 */
proto.worklayer.internal.v1.Job.prototype.getResolution = function() {
  return /** @type {!proto.worklayer.internal.v1.Resolution} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Resolution} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setResolution = function(value) {
  return jspb.Message.setProto3EnumField(this, 26, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal rating_received = 27;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.prototype.getRatingReceived = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 27));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setRatingReceived = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearRatingReceived = function() {
  return this.setRatingReceived(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasRatingReceived = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional google.protobuf.StringValue rating_received_comment = 28;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.prototype.getRatingReceivedComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 28));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setRatingReceivedComment = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearRatingReceivedComment = function() {
  return this.setRatingReceivedComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasRatingReceivedComment = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal rating_submitted = 29;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.prototype.getRatingSubmitted = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 29));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setRatingSubmitted = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearRatingSubmitted = function() {
  return this.setRatingSubmitted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasRatingSubmitted = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.protobuf.StringValue rating_submitted_comment = 30;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Job.prototype.getRatingSubmittedComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 30));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setRatingSubmittedComment = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearRatingSubmittedComment = function() {
  return this.setRatingSubmittedComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasRatingSubmittedComment = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * repeated string rating_submitted_categories = 31;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.prototype.getRatingSubmittedCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 31));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setRatingSubmittedCategoriesList = function(value) {
  return jspb.Message.setField(this, 31, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.addRatingSubmittedCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 31, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearRatingSubmittedCategoriesList = function() {
  return this.setRatingSubmittedCategoriesList([]);
};


/**
 * optional worklayer.shared.types.v1.Decimal paid_amount = 32;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.prototype.getPaidAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 32));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setPaidAmount = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearPaidAmount = function() {
  return this.setPaidAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasPaidAmount = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal total = 33;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.prototype.getTotal = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 33));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setTotal = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearTotal = function() {
  return this.setTotal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasTotal = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional PaymentInfoStatus payment_info_status = 34;
 * @return {!proto.worklayer.internal.v1.Job.PaymentInfoStatus}
 */
proto.worklayer.internal.v1.Job.prototype.getPaymentInfoStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.Job.PaymentInfoStatus} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Job.PaymentInfoStatus} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setPaymentInfoStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 34, value);
};


/**
 * optional WaitingOn waiting_on = 35;
 * @return {!proto.worklayer.internal.v1.WaitingOn}
 */
proto.worklayer.internal.v1.Job.prototype.getWaitingOn = function() {
  return /** @type {!proto.worklayer.internal.v1.WaitingOn} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.WaitingOn} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setWaitingOn = function(value) {
  return jspb.Message.setProto3EnumField(this, 35, value);
};


/**
 * optional google.protobuf.Timestamp date_deadline = 36;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.prototype.getDateDeadline = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 36));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDateDeadline = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDateDeadline = function() {
  return this.setDateDeadline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDateDeadline = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional bool archived = 37;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.getArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 37, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 37, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal coupon_amount = 38;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.prototype.getCouponAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 38));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setCouponAmount = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearCouponAmount = function() {
  return this.setCouponAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasCouponAmount = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * repeated JobScopeItem job_scope_items = 39;
 * @return {!Array<!proto.worklayer.internal.v1.Job.JobScopeItem>}
 */
proto.worklayer.internal.v1.Job.prototype.getJobScopeItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Job.JobScopeItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Job.JobScopeItem, 39));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Job.JobScopeItem>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setJobScopeItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 39, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Job.JobScopeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job.JobScopeItem}
 */
proto.worklayer.internal.v1.Job.prototype.addJobScopeItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 39, opt_value, proto.worklayer.internal.v1.Job.JobScopeItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearJobScopeItemsList = function() {
  return this.setJobScopeItemsList([]);
};


/**
 * repeated Amendment amendments = 40;
 * @return {!Array<!proto.worklayer.internal.v1.Job.Amendment>}
 */
proto.worklayer.internal.v1.Job.prototype.getAmendmentsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Job.Amendment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Job.Amendment, 40));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Job.Amendment>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setAmendmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 40, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Job.Amendment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job.Amendment}
 */
proto.worklayer.internal.v1.Job.prototype.addAmendments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 40, opt_value, proto.worklayer.internal.v1.Job.Amendment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearAmendmentsList = function() {
  return this.setAmendmentsList([]);
};


/**
 * optional google.protobuf.Timestamp date_last_activity = 41;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.prototype.getDateLastActivity = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 41));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDateLastActivity = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDateLastActivity = function() {
  return this.setDateLastActivity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDateLastActivity = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional PayoutSplit payout_split = 42;
 * @return {?proto.worklayer.internal.v1.Job.PayoutSplit}
 */
proto.worklayer.internal.v1.Job.prototype.getPayoutSplit = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.PayoutSplit} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.PayoutSplit, 42));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.PayoutSplit|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setPayoutSplit = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearPayoutSplit = function() {
  return this.setPayoutSplit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasPayoutSplit = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal calling_actor_allocation = 43;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.prototype.getCallingActorAllocation = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 43));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setCallingActorAllocation = function(value) {
  return jspb.Message.setWrapperField(this, 43, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearCallingActorAllocation = function() {
  return this.setCallingActorAllocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasCallingActorAllocation = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal primary_amount = 44;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.prototype.getPrimaryAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 44));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setPrimaryAmount = function(value) {
  return jspb.Message.setWrapperField(this, 44, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearPrimaryAmount = function() {
  return this.setPrimaryAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasPrimaryAmount = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal admin_fee_amount = 45;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.prototype.getAdminFeeAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 45));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setAdminFeeAmount = function(value) {
  return jspb.Message.setWrapperField(this, 45, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearAdminFeeAmount = function() {
  return this.setAdminFeeAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasAdminFeeAmount = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * repeated string stripe_charges = 46;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.prototype.getStripeChargesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 46));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setStripeChargesList = function(value) {
  return jspb.Message.setField(this, 46, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.addStripeCharges = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 46, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearStripeChargesList = function() {
  return this.setStripeChargesList([]);
};


/**
 * optional BillingType billing_type = 47;
 * @return {!proto.worklayer.internal.v1.Job.BillingType}
 */
proto.worklayer.internal.v1.Job.prototype.getBillingType = function() {
  return /** @type {!proto.worklayer.internal.v1.Job.BillingType} */ (jspb.Message.getFieldWithDefault(this, 47, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Job.BillingType} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setBillingType = function(value) {
  return jspb.Message.setProto3EnumField(this, 47, value);
};


/**
 * repeated string coverage_states = 48;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.prototype.getCoverageStatesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 48));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setCoverageStatesList = function(value) {
  return jspb.Message.setField(this, 48, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.addCoverageStates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 48, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearCoverageStatesList = function() {
  return this.setCoverageStatesList([]);
};


/**
 * optional string resolution_reason = 49;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.prototype.getResolutionReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setResolutionReason = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};


/**
 * repeated string years = 50;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.prototype.getYearsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 50));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setYearsList = function(value) {
  return jspb.Message.setField(this, 50, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.addYears = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 50, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearYearsList = function() {
  return this.setYearsList([]);
};


/**
 * optional worklayer.shared.types.v1.Decimal amended_amount = 51;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Job.prototype.getAmendedAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 51));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setAmendedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 51, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearAmendedAmount = function() {
  return this.setAmendedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasAmendedAmount = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * repeated string coupon_ids = 52;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.prototype.getCouponIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 52));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setCouponIdsList = function(value) {
  return jspb.Message.setField(this, 52, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.addCouponIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 52, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearCouponIdsList = function() {
  return this.setCouponIdsList([]);
};


/**
 * repeated string rating_received_categories = 53;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.prototype.getRatingReceivedCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 53));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setRatingReceivedCategoriesList = function(value) {
  return jspb.Message.setField(this, 53, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.addRatingReceivedCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 53, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearRatingReceivedCategoriesList = function() {
  return this.setRatingReceivedCategoriesList([]);
};


/**
 * optional google.protobuf.Timestamp date_reopened = 54;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.prototype.getDateReopened = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 54));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDateReopened = function(value) {
  return jspb.Message.setWrapperField(this, 54, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDateReopened = function() {
  return this.setDateReopened(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDateReopened = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * optional google.protobuf.Timestamp date_last_stale = 55;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Job.prototype.getDateLastStale = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 55));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setDateLastStale = function(value) {
  return jspb.Message.setWrapperField(this, 55, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearDateLastStale = function() {
  return this.setDateLastStale(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasDateLastStale = function() {
  return jspb.Message.getField(this, 55) != null;
};


/**
 * optional bool stale = 56;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.getStale = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 56, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setStale = function(value) {
  return jspb.Message.setProto3BooleanField(this, 56, value);
};


/**
 * repeated string stripe_payouts = 58;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Job.prototype.getStripePayoutsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 58));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setStripePayoutsList = function(value) {
  return jspb.Message.setField(this, 58, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.addStripePayouts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 58, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearStripePayoutsList = function() {
  return this.setStripePayoutsList([]);
};


/**
 * optional string current_milestone_id = 59;
 * @return {string}
 */
proto.worklayer.internal.v1.Job.prototype.getCurrentMilestoneId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 59, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setCurrentMilestoneId = function(value) {
  return jspb.Message.setProto3StringField(this, 59, value);
};


/**
 * optional Consultation consultation = 60;
 * @return {?proto.worklayer.internal.v1.Consultation}
 */
proto.worklayer.internal.v1.Job.prototype.getConsultation = function() {
  return /** @type{?proto.worklayer.internal.v1.Consultation} */ (
    jspb.Message.getWrapperField(this, internal_consultation_pb.Consultation, 60));
};


/**
 * @param {?proto.worklayer.internal.v1.Consultation|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setConsultation = function(value) {
  return jspb.Message.setWrapperField(this, 60, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearConsultation = function() {
  return this.setConsultation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasConsultation = function() {
  return jspb.Message.getField(this, 60) != null;
};


/**
 * optional JobProgressionStepStatus progression_step = 61;
 * @return {!proto.worklayer.internal.v1.JobProgressionStepStatus}
 */
proto.worklayer.internal.v1.Job.prototype.getProgressionStep = function() {
  return /** @type {!proto.worklayer.internal.v1.JobProgressionStepStatus} */ (jspb.Message.getFieldWithDefault(this, 61, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionStepStatus} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setProgressionStep = function(value) {
  return jspb.Message.setProto3EnumField(this, 61, value);
};


/**
 * optional JobScopeChangeStatus scope_change_status = 62;
 * @return {!proto.worklayer.internal.v1.JobScopeChangeStatus}
 */
proto.worklayer.internal.v1.Job.prototype.getScopeChangeStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.JobScopeChangeStatus} */ (jspb.Message.getFieldWithDefault(this, 62, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobScopeChangeStatus} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setScopeChangeStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 62, value);
};


/**
 * optional PurgeStatus purge_status = 63;
 * @return {!proto.worklayer.internal.v1.PurgeStatus}
 */
proto.worklayer.internal.v1.Job.prototype.getPurgeStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.PurgeStatus} */ (jspb.Message.getFieldWithDefault(this, 63, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.PurgeStatus} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setPurgeStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 63, value);
};


/**
 * optional DeprecatedJobType deprecated_job_type = 64;
 * @return {!proto.worklayer.internal.v1.Job.DeprecatedJobType}
 */
proto.worklayer.internal.v1.Job.prototype.getDeprecatedJobType = function() {
  return /** @type {!proto.worklayer.internal.v1.Job.DeprecatedJobType} */ (jspb.Message.getFieldWithDefault(this, 64, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Job.DeprecatedJobType} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.setDeprecatedJobType = function(value) {
  return jspb.Message.setProto3EnumField(this, 64, value);
};


/**
 * optional JobType type = 65;
 * @return {?proto.worklayer.internal.v1.Job.JobType}
 */
proto.worklayer.internal.v1.Job.prototype.getType = function() {
  return /** @type{?proto.worklayer.internal.v1.Job.JobType} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job.JobType, 65));
};


/**
 * @param {?proto.worklayer.internal.v1.Job.JobType|undefined} value
 * @return {!proto.worklayer.internal.v1.Job} returns this
*/
proto.worklayer.internal.v1.Job.prototype.setType = function(value) {
  return jspb.Message.setWrapperField(this, 65, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Job} returns this
 */
proto.worklayer.internal.v1.Job.prototype.clearType = function() {
  return this.setType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Job.prototype.hasType = function() {
  return jspb.Message.getField(this, 65) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListJobQuestionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListJobQuestionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    answersMap: (f = msg.getAnswersMap()) ? f.toObject(includeInstance, proto.worklayer.internal.v1.InputValue.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListJobQuestionsRequest}
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListJobQuestionsRequest;
  return proto.worklayer.internal.v1.ListJobQuestionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListJobQuestionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListJobQuestionsRequest}
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = msg.getAnswersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.worklayer.internal.v1.InputValue.deserializeBinaryFromReader, "", new proto.worklayer.internal.v1.InputValue());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListJobQuestionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListJobQuestionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnswersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.worklayer.internal.v1.InputValue.serializeBinaryToWriter);
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListJobQuestionsRequest} returns this
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * map<string, InputValue> answers = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.worklayer.internal.v1.InputValue>}
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest.prototype.getAnswersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.worklayer.internal.v1.InputValue>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.worklayer.internal.v1.InputValue));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.worklayer.internal.v1.ListJobQuestionsRequest} returns this
 */
proto.worklayer.internal.v1.ListJobQuestionsRequest.prototype.clearAnswersMap = function() {
  this.getAnswersMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListJobQuestionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListJobQuestionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    intakeCompleted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    questionsList: jspb.Message.toObjectList(msg.getQuestionsList(),
    internal_question_input_value_pb.Question.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListJobQuestionsResponse}
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListJobQuestionsResponse;
  return proto.worklayer.internal.v1.ListJobQuestionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListJobQuestionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListJobQuestionsResponse}
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIntakeCompleted(value);
      break;
    case 2:
      var value = new internal_question_input_value_pb.Question;
      reader.readMessage(value,internal_question_input_value_pb.Question.deserializeBinaryFromReader);
      msg.addQuestions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListJobQuestionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListJobQuestionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntakeCompleted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getQuestionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      internal_question_input_value_pb.Question.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool intake_completed = 1;
 * @return {boolean}
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.prototype.getIntakeCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.ListJobQuestionsResponse} returns this
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.prototype.setIntakeCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated Question questions = 2;
 * @return {!Array<!proto.worklayer.internal.v1.Question>}
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.prototype.getQuestionsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Question>} */ (
    jspb.Message.getRepeatedWrapperField(this, internal_question_input_value_pb.Question, 2));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Question>} value
 * @return {!proto.worklayer.internal.v1.ListJobQuestionsResponse} returns this
*/
proto.worklayer.internal.v1.ListJobQuestionsResponse.prototype.setQuestionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Question=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Question}
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.prototype.addQuestions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.worklayer.internal.v1.Question, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListJobQuestionsResponse} returns this
 */
proto.worklayer.internal.v1.ListJobQuestionsResponse.prototype.clearQuestionsList = function() {
  return this.setQuestionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Milestone.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Milestone.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Milestone.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Milestone} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Milestone.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    completed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    tasksList: jspb.Message.toObjectList(msg.getTasksList(),
    proto.worklayer.internal.v1.MilestoneTask.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Milestone}
 */
proto.worklayer.internal.v1.Milestone.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Milestone;
  return proto.worklayer.internal.v1.Milestone.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Milestone} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Milestone}
 */
proto.worklayer.internal.v1.Milestone.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleted(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.MilestoneTask;
      reader.readMessage(value,proto.worklayer.internal.v1.MilestoneTask.deserializeBinaryFromReader);
      msg.addTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Milestone.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Milestone.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Milestone} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Milestone.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCompleted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.worklayer.internal.v1.MilestoneTask.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Milestone.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Milestone} returns this
 */
proto.worklayer.internal.v1.Milestone.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Milestone.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Milestone} returns this
 */
proto.worklayer.internal.v1.Milestone.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool completed = 3;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Milestone.prototype.getCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Milestone} returns this
 */
proto.worklayer.internal.v1.Milestone.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated MilestoneTask tasks = 4;
 * @return {!Array<!proto.worklayer.internal.v1.MilestoneTask>}
 */
proto.worklayer.internal.v1.Milestone.prototype.getTasksList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.MilestoneTask>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.MilestoneTask, 4));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.MilestoneTask>} value
 * @return {!proto.worklayer.internal.v1.Milestone} returns this
*/
proto.worklayer.internal.v1.Milestone.prototype.setTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.worklayer.internal.v1.MilestoneTask=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.MilestoneTask}
 */
proto.worklayer.internal.v1.Milestone.prototype.addTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.worklayer.internal.v1.MilestoneTask, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Milestone} returns this
 */
proto.worklayer.internal.v1.Milestone.prototype.clearTasksList = function() {
  return this.setTasksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.MilestoneTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.MilestoneTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.MilestoneTask.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    completed: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dateCompleted: (f = msg.getDateCompleted()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    designee: jspb.Message.getFieldWithDefault(msg, 4, 0),
    completedByPublicId: (f = msg.getCompletedByPublicId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.MilestoneTask}
 */
proto.worklayer.internal.v1.MilestoneTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.MilestoneTask;
  return proto.worklayer.internal.v1.MilestoneTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.MilestoneTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.MilestoneTask}
 */
proto.worklayer.internal.v1.MilestoneTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleted(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCompleted(value);
      break;
    case 4:
      var value = /** @type {!proto.worklayer.internal.v1.MilestoneTask.TaskDesignee} */ (reader.readEnum());
      msg.setDesignee(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCompletedByPublicId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.MilestoneTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.MilestoneTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.MilestoneTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompleted();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDateCompleted();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDesignee();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCompletedByPublicId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.MilestoneTask.TaskDesignee = {
  TASK_DESIGNEE_UNSPECIFIED: 0,
  CLIENT: 1,
  PROVIDER: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool completed = 2;
 * @return {boolean}
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.getCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp date_completed = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.getDateCompleted = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.MilestoneTask} returns this
*/
proto.worklayer.internal.v1.MilestoneTask.prototype.setDateCompleted = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.clearDateCompleted = function() {
  return this.setDateCompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.hasDateCompleted = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TaskDesignee designee = 4;
 * @return {!proto.worklayer.internal.v1.MilestoneTask.TaskDesignee}
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.getDesignee = function() {
  return /** @type {!proto.worklayer.internal.v1.MilestoneTask.TaskDesignee} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.MilestoneTask.TaskDesignee} value
 * @return {!proto.worklayer.internal.v1.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.setDesignee = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue completed_by_public_id = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.getCompletedByPublicId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.MilestoneTask} returns this
*/
proto.worklayer.internal.v1.MilestoneTask.prototype.setCompletedByPublicId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.MilestoneTask} returns this
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.clearCompletedByPublicId = function() {
  return this.setCompletedByPublicId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.MilestoneTask.prototype.hasCompletedByPublicId = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobCreatedRealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobCreatedRealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobCreatedRealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobCreatedRealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    job: (f = msg.getJob()) && proto.worklayer.internal.v1.Job.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobCreatedRealtimeEvent}
 */
proto.worklayer.internal.v1.JobCreatedRealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobCreatedRealtimeEvent;
  return proto.worklayer.internal.v1.JobCreatedRealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobCreatedRealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobCreatedRealtimeEvent}
 */
proto.worklayer.internal.v1.JobCreatedRealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.Job;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.deserializeBinaryFromReader);
      msg.setJob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobCreatedRealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobCreatedRealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobCreatedRealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobCreatedRealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJob();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.Job.serializeBinaryToWriter
    );
  }
};


/**
 * optional Job job = 1;
 * @return {?proto.worklayer.internal.v1.Job}
 */
proto.worklayer.internal.v1.JobCreatedRealtimeEvent.prototype.getJob = function() {
  return /** @type{?proto.worklayer.internal.v1.Job} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.Job|undefined} value
 * @return {!proto.worklayer.internal.v1.JobCreatedRealtimeEvent} returns this
*/
proto.worklayer.internal.v1.JobCreatedRealtimeEvent.prototype.setJob = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobCreatedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.JobCreatedRealtimeEvent.prototype.clearJob = function() {
  return this.setJob(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobCreatedRealtimeEvent.prototype.hasJob = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobUpdatedRealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    job: (f = msg.getJob()) && proto.worklayer.internal.v1.Job.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobUpdatedRealtimeEvent;
  return proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobUpdatedRealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.Job;
      reader.readMessage(value,proto.worklayer.internal.v1.Job.deserializeBinaryFromReader);
      msg.setJob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobUpdatedRealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJob();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.Job.serializeBinaryToWriter
    );
  }
};


/**
 * optional Job job = 1;
 * @return {?proto.worklayer.internal.v1.Job}
 */
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.prototype.getJob = function() {
  return /** @type{?proto.worklayer.internal.v1.Job} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Job, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.Job|undefined} value
 * @return {!proto.worklayer.internal.v1.JobUpdatedRealtimeEvent} returns this
*/
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.prototype.setJob = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobUpdatedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.prototype.clearJob = function() {
  return this.setJob(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobUpdatedRealtimeEvent.prototype.hasJob = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.MakeCorrectionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.MakeCorrectionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    answersMap: (f = msg.getAnswersMap()) ? f.toObject(includeInstance, proto.worklayer.internal.v1.InputValue.toObject) : [],
    reason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.MakeCorrectionsRequest}
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.MakeCorrectionsRequest;
  return proto.worklayer.internal.v1.MakeCorrectionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.MakeCorrectionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.MakeCorrectionsRequest}
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = msg.getAnswersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.worklayer.internal.v1.InputValue.deserializeBinaryFromReader, "", new proto.worklayer.internal.v1.InputValue());
         });
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.MakeCorrectionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.MakeCorrectionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnswersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.worklayer.internal.v1.InputValue.serializeBinaryToWriter);
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.MakeCorrectionsRequest} returns this
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * map<string, InputValue> answers = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.worklayer.internal.v1.InputValue>}
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.prototype.getAnswersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.worklayer.internal.v1.InputValue>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.worklayer.internal.v1.InputValue));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.worklayer.internal.v1.MakeCorrectionsRequest} returns this
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.prototype.clearAnswersMap = function() {
  this.getAnswersMap().clear();
  return this;};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.MakeCorrectionsRequest} returns this
 */
proto.worklayer.internal.v1.MakeCorrectionsRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.MakeCorrectionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.MakeCorrectionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.MakeCorrectionsResponse}
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.MakeCorrectionsResponse;
  return proto.worklayer.internal.v1.MakeCorrectionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.MakeCorrectionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.MakeCorrectionsResponse}
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.MakeCorrectionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.MakeCorrectionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.MakeCorrectionsResponse} returns this
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.MakeCorrectionsResponse} returns this
*/
proto.worklayer.internal.v1.MakeCorrectionsResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.MakeCorrectionsResponse} returns this
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.MakeCorrectionsResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CompleteInfoGatheringRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CompleteInfoGatheringRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    completeAsAdmin: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CompleteInfoGatheringRequest}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CompleteInfoGatheringRequest;
  return proto.worklayer.internal.v1.CompleteInfoGatheringRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CompleteInfoGatheringRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CompleteInfoGatheringRequest}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleteAsAdmin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CompleteInfoGatheringRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CompleteInfoGatheringRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompleteAsAdmin();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CompleteInfoGatheringRequest} returns this
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool complete_as_admin = 2;
 * @return {boolean}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest.prototype.getCompleteAsAdmin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.CompleteInfoGatheringRequest} returns this
 */
proto.worklayer.internal.v1.CompleteInfoGatheringRequest.prototype.setCompleteAsAdmin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.CompleteInfoGatheringResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.CompleteInfoGatheringResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.CompleteInfoGatheringResponse}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.CompleteInfoGatheringResponse;
  return proto.worklayer.internal.v1.CompleteInfoGatheringResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.CompleteInfoGatheringResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.CompleteInfoGatheringResponse}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    case 3:
      var value = /** @type {!proto.worklayer.internal.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.CompleteInfoGatheringResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.CompleteInfoGatheringResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.CompleteInfoGatheringResponse} returns this
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.CompleteInfoGatheringResponse} returns this
*/
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.CompleteInfoGatheringResponse} returns this
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Status status = 3;
 * @return {!proto.worklayer.internal.v1.Status}
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Status} value
 * @return {!proto.worklayer.internal.v1.CompleteInfoGatheringResponse} returns this
 */
proto.worklayer.internal.v1.CompleteInfoGatheringResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RequestJobChampionProviderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    providerUserPublicId: (f = msg.getProviderUserPublicId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RequestJobChampionProviderRequest;
  return proto.worklayer.internal.v1.RequestJobChampionProviderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProviderUserPublicId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RequestJobChampionProviderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProviderUserPublicId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} returns this
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue provider_user_public_id = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.prototype.getProviderUserPublicId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} returns this
*/
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.prototype.setProviderUserPublicId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RequestJobChampionProviderRequest} returns this
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.prototype.clearProviderUserPublicId = function() {
  return this.setProviderUserPublicId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderRequest.prototype.hasProviderUserPublicId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RequestJobChampionProviderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RequestJobChampionProviderResponse}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RequestJobChampionProviderResponse;
  return proto.worklayer.internal.v1.RequestJobChampionProviderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RequestJobChampionProviderResponse}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RequestJobChampionProviderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RequestJobChampionProviderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RequestJobChampionProviderResponse} returns this
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.RequestJobChampionProviderResponse} returns this
*/
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RequestJobChampionProviderResponse} returns this
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RequestJobChampionProviderResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.ConsultationIncompleteReason = {
  REASON_UNSPECIFIED: 0,
  CONSULTATION_UNNECESSARY: 1,
  CLIENT_MISSED_CALL: 2,
  PRO_MISSED_CALL: 3,
  PREVIOUS_PRO_COMPLETED_CALL: 4,
  COMPLETED_VIA_CHAT: 5
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.SearchJobScopeOption = {
  MINE: 0,
  ALL: 1
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.MemberType = {
  MEMBER_TYPE_UNSPECIFIED: 0,
  MEMBER_TYPE_PROVIDER: 1,
  MEMBER_TYPE_CLIENT: 2
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.MemberRoleType = {
  MEMBER_ROLE_TYPE_UNSPECIFIED: 0,
  SUPPORTING: 1,
  CHAMPION: 2
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Status = {
  STATUS_UNSPECIFIED: 0,
  UNDER_CONSTRUCTION: 1,
  UNCLAIMED: 2,
  CLAIMED: 3,
  CLOSED: 4,
  IDLE: 5,
  ON_HOLD: 6,
  INFO_GATHERING: 7
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Resolution = {
  RESOLUTION_UNSPECIFIED: 0,
  DONE: 1,
  CANCELLED: 2,
  TEST: 3
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.WaitingOn = {
  WAITING_ON_UNSPECIFIED: 0,
  WAITING_ON_CLIENT: 1,
  WAITING_ON_PRO: 2
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.AmendmentVisibility = {
  PUBLIC: 0,
  INTERNAL: 1
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.PurgeStatus = {
  PURGE_STATUS_NONE: 0,
  PURGE_STATUS_SCHEDULED: 1,
  PURGE_STATUS_COMPLETED: 2
};

goog.object.extend(exports, proto.worklayer.internal.v1);
